<template>
    <div class="story-page">
    <div class="header2">
        <nav class="chapter-navigation" 
        :class="{ 'mobile-nav-visible': isMenuVisible }">
          <button @click="toggleMenu" class="close-button">
            &times;
          </button>
          <ul class="quick-links">
            <li v-for="(chapter, index) in chapters" :key="index" :class="{ 'disabled-link': !chapter.isAvailable }">
              <a v-if="chapter.isAvailable" :href="'#' + chapter.id" @click.prevent="scrollToChapter(chapter.id)" style="text-align:center">
                Chapter {{ chapter.chapterNumber }}: {{ chapter.title }}
              </a>
              <span v-else>
                Chapter {{ chapter.chapterNumber }}: {{ chapter.title }} - - Coming Soon
              </span>
              <!--
              <div v-if="chapter.isAvailable" class="rating-buttons">
                <button @click="rateChapter(chapter.id, 'up')" class="thumbs-up">👍</button>
                <button @click="rateChapter(chapter.id, 'down')" class="thumbs-down">👎</button>
              </div>-->
            </li>
          </ul>
        </nav>  
    </div>


    <header class="story-header">
      <div class="header-container">
        <h1 style="text-align:center;">{{ storyTitle }}</h1>
        <button @click="toggleMenu" class="hamburger-button">
          ☰
        </button>
      </div>
    </header>

    <main class="story-content">
      <section v-for="(chapter, index) in chapters" :key="index" :id="chapter.id" class="chapter-section">
        <h2 v-if="chapter.isAvailable">Chapter {{ chapter.chapterNumber }}: {{ chapter.title }}</h2>
        <div v-if="chapter.isAvailable" class="chapter-text" v-html="chapter.content"></div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'StoryView',
  data() {
    return {
      storyTitle: 'Playing the Game',
      chapters: [
        {
          id: 'chapter-1',
          chapterNumber: 1,
          title: `New Horizons`,
          content: `
          <p style="text-indent: 50px">
          It was silent in the office as Allyson and Cealen took in their latest and most 
          dangerous assignment.  The director of the prominent newspaper, The Empire, didn't say 
          anything.  He allowed them to take in his request and think it over.  Allyson and Cealen 
          were his best pair of journalists in The Empire’s history.  If anyone could crack into the 
          truth of Niveal, it was Allyson and Cealen.  The ask was simple.  The director requested 
          that Allyson and Cealen move to the small, isolated town of Niveal and expand The Empire’s 
          reach.</p>
<p style="text-indent: 50px">
Allyson thought about it, tapping her fingers to her lips.  She was an intrepid reporter with a 
taste for adventure.  She loved investigating into a story until she reached the shocking truth.  
“Why Niveal though?”  She asked the director.  In Allyson’s opinion, Niveal seemed boring.  There 
were parades, festivals, and other events that merited the pages of The Empire, but they already had 
plenty of that fan fair.  Allyson narrowed her eyes at the director.  She knew if he was asking them, 
the dynamic duo of The Empire, there was something more going on.  “What are you not telling us?”
</p>
<p style="text-indent: 50px">
“Ally!”  Cealen muttered.  He was sweating and wringing his hands.  “Haven’t you heard?  Niveal has 
a lot of gangs!”  Cealen sighed and rubbed his forehead.  “I’m not ok with this.  Can’t Ally move 
there and just send me the stories?  I’m not a field man!  I’m an office man!”  Cealen pleaded with 
the director.  He was a master word smith with a gift to turn any story into front page news.  His 
sensational headlines set Cealen on the fast track to success.  With the stories and interviews that 
Allyson was able to collect, The Empire shot to the number one best media outlet in the country.  That 
was why the director chose them for this new mission. </p>
<p style="text-indent: 50px">
“Look.”  The director said, resting his hands on the table.  “Niveal has secrets that no other paper 
has been able to expose.  This is our chance to expose what is really happening there.” </p>
<p style="text-indent: 50px">
“Journalists have been killed in Niveal for trying to expose what is really happening!  There was a 
video on the news yesterday of a public hanging in Niveal.”  Cealen yelped.  “We could be next!” </p>
<p style="text-indent: 50px">
“Why us and not another team?  What do you think is going on?”  Allyson asked, narrowing her eyes at 
the director.  “I won’t put Cealen in danger for just some generic, run-of-the-mill Ponzi scheme.”  
Allyson leaned closer.  Her keen sense for drama was filling her blood with adrenaline.  There was a 
big story here, she could tell.  “What are you not telling us, director?”</p>
<p style="text-indent: 50px">
The director scoffed and folded his hands together.  Allyson’s nose for a story could sniff out the 
truth, no matter how many layers of lies and deception it was under.  That was one of the reasons the 
pair thrived in this cut-throat industry.  Allyson had the tenacity for hunting down leads, and Cealen 
had the prose to captivate the public.  The director needed them to investigate what was going on in 
Niveal.</p>
<p style="text-indent: 50px">
“Because you’re the best.”  The director said through a groan.  He opened his desk drawer and slid a 
photograph over to the pair.  Allyson and Cealen both leaned forward to look at the photo.  Despite 
their differences, they were both curious and passionate journalists. </p>
<p style="text-indent: 50px">
“Who is this woman?”  Cealen asked, picking up the photo.  “She’s pretty.”</p>
<p style="text-indent: 50px">
“She’s currently missing.”  The director said.  Allyson and Cealen both gasped.  “While it’s true we 
need journalists to cover the news in Niveal, I want the two of you to go there to find Dolores.”  He 
pointed at the photo.  “That’s Dolores.” </p>
<p style="text-indent: 50px">
“I knew it!”  Allyson exclaimed.  She pulled out her notepad and paper from the inside pocket of her 
leather jacket.  “Where was Dolores last seen?” </p>
<p style="text-indent: 50px">
“Ally!”  Cealen scolded.  He shook his head and laid the photo back on the table.  “We are reporters 
of the truth, not private investigators!  This is the kind of stuff for police.” </p>
<p style="text-indent: 50px">
“The police were contacted.  They could never find anything.”  The director muttered.  “Corruption is 
rampant in Niveal, among other things, so I need the two of you to investigate.  Use discretion and 
fall back on The Empire whenever you need to.”  He rubbed his forehead as he glanced at the picture.  
“Dolores is the wife of a good friend.  She hasn’t been seen for months, and they are afraid something 
happened to her in Niveal.”  He glanced at Allyson, who was scribbling notes.  “Her last known 
whereabouts were a nightclub in Niveal called The Rec Room.  It's a college bar that holds events for 
the university.  Dolores was a student there, a social studies major.”</p>
<p style="text-indent: 50px">
“Aye yah… Ally.”  Cealen groaned, shaking his head.  “This is dangerous!  We could get killed.”  There 
were a million reasons for why they should refuse.  It was a dangerous city where people disappeared 
all the time.  Crime was higher than most larger cities in their state, and there were rumors that the 
mayor was on the payroll of various gangs.  Cealen covered his mouth as he stared at the picture of 
Dolores.  Despite his fears, Cealen wanted to help find the missing woman.  He hated when women were 
preyed upon.
His first big break as a journalist was reporting on a series of rapes.  The police were able to find 
the criminal with Allyson and Cealen’s coverage of the case.</p>
<p style="text-indent: 50px">
“Leave it to us, boss!”  Allyson said, stowing away her notepad.  “If we are going to do this, we 
need resources.”  She folded her arms and leaned back in her chair.  “We also need double the pay.”  
The director chuckled.  He expected this.  To find Dolores, he would pay Allyson and Cealen any price.</p>
<p style="text-indent: 50px">
“Done.”  The director said.  “Does that mean you accept?” </p>
<p style="text-indent: 50px">
Allyson and Cealen exchanged a nervous look.  After a while, Cealen caved.  “Fine.”  Cealen muttered.  
“We accept.”  He side-eyed Allyson with a grin.  She would have accepted with or without his 
approval.  He would have caved under her persuasive tactics, and they both knew that.  It was pointless to 
refuse her.  “When do we leave?” </p>
<p style="text-indent: 50px">
“Tonight!”  Allyson said, springing out of her seat.  “I’ll book us a hotel.”  She took out her phone 
and snapped a picture of Dolores.  “When you’re ready, Cealen, just swing by my place.  We’ll leave 
from there.”  Allyson said.  She took a breath and threw her hands on her hips.  “Don't worry, 
director.  We’ll find out what happened to Dolores.”  The director nodded as the pair walked out.  
He wasn’t worried.  If anyone could handle this case, it was Allyson and Cealen.  He sat in his 
office in silence.  This was going to be a dangerous task for them.  It wasn’t without its risk, and 
Cealen was right to be worried.  The director didn't want to mention it in front of them, but The 
Empire had already lost a pair of journalists to the gang fighting in Niveal.</p>
<p style="text-indent: 50px">
“Good luck, guys.”  The director muttered.  “You’ll need it.
</p><br>
<p style="text-indent: 50px">
“We made it!”  Cealen sighed when he opened the door to their motel room.  Niveal was expensive, so 
for their first week, Allyson booked one of the cheaper motels on the edge of the city.  They were a 
twenty-minute walk from downtown, but the motel was in a low foot traffic area.  Now that they were 
on assignment, they were both on guard.  Allyson made sure to book a room on the second floor, so 
there wouldn't be any danger from passer-bys.  Nobody would be able to smash their window and attack 
them while they slept, like what happened when they were covering a court case.  The offender’s people 
tried to kill Allyson and Cealan to keep the details of the case from the public.  Over the years 
of working together, the pair came up with certain practices to keep each other safe.  Cealen put his 
bag down next to the door and stepped aside.</p>
<p style="text-indent: 50px">
“Ladies first.”  Cealen chuckled with a smile.</p>
<p style="text-indent: 50px">
Allyson nodded and set her bag down on the floor.  This was normal for them.  Allyson went around the 
room, checking for wire bugs, recording devices, and anything that the gangsters of Niveal might try.  
Cealen got out his phone and did a sweep of the Wi-Fi signals in the area.  There were no obvious 
signs of third parties listening in on the internet traffic.  Just to be sure, he opened his sentinel 
app and connected to the motel Wi-Fi.  Right away, he got several pings from unknown devices listening. </p>
<p style="text-indent: 50px">
“No bugs.”  Allyson said, setting down the mattress of the second queen-sized bed.  She dusted off 
her hands on her pants.  “The room’s clean.”  She glanced at Cealen.  “How about the signal?” </p>
<p style="text-indent: 50px">
“It’s not safe.”  Cealen answered.  “Not for others, anyway.”  He turned on his AI security protocol 
that would mask their network traffic under a different subnet.  “Make sure to turn on the AI 
security.  The network is a party line.”  He grabbed his bag and threw it on the bed farthest away 
from the door.  When they were on assignments together, it was better for both of them to stay close.  
Allyson and Cealen were good friends and didn't find the shared motel room an issue.  “Now what?”  
It was just past noon.  They had started their journey before dawn, and they were both exhausted and 
hungry. </p>
<p style="text-indent: 50px">
“Now.”  Allyson said, throwing her bag on the other bed.  She pulled out her nine millimeter and 
checked the magazine.  “I’ll check out town, get a lay of the land.”  Allyson said, glancing at 
Cealen.  He was taking out his computer and other accessories.  For this mission, Cealen brought a 
signal scrambler, a couple of burner phones, and motion based security cameras that would email him 
with security updates.  “You good with getting us some chow?” </p>
<p style="text-indent: 50px">
Cealen nodded.  “Of course.”  He grabbed one of the burner phones and tossed it on Allyson’s bed.  
“Take one.  There is no telling who you might run into.”  Cealen offered in warning.  They were both 
prepared for trouble. </p>
<p style="text-indent: 50px">
“I’ll be back before dark.”  Allyson said.  She hesitated in dropping her pistol into her shoulder 
holster.  “If not, you know what to do.”  Cealen pursed his lips but nodded.  It was much faster to 
report a dangerous threat to the police than a missing person.  For their dangerous assignments, Cealen 
would call the police and report Allyson as a suspicious person if she was caught up in trouble.  Her 
press pass would clear her in most cases, but it was still a risk.  Allyson had a record of causing 
trouble, so his reports had validity.  Niveal was different from other cities, though.  With the 
police in the pocket of the gangs, Cealen was nervous about reporting Allyson. </p>
<p style="text-indent: 50px">
“If you aren’t back by midnight, I’ll call the director for backup.”  Cealen told her.  It was his 
way of letting Allyson know he was worried.  Allyson smiled and nodded. </p>
<p style="text-indent: 50px">
“Same!”  Allyson said, picking up the burner phone.  “There’s a grocery store around the corner.  
Just get stuff for tonight.  We’ll figure out the rest tomorrow.”  Cealen nodded. </p>
<p style="text-indent: 50px">
“You should see the university if you can.  That way, we can see how far it is.  I’ll search the 
realestate listings to see if anything comes up for rent.”  Cealen sat down on the edge of his 
bed and ran a hand through his hair.  “Hopefully, we aren't here that long to need anything like 
that.” </p>
<p style="text-indent: 50px">
“What?”  Allyson teased.  “We are journalist!  We are here for The Empire.”  She grabbed her motel 
card key and headed for the door.  “That means we can expect to be here for at least six months.”  
She had everything she needed in her leather jacket pockets.  “I’ll text if I find the university.”  
She waved at Cealen before heading out. </p>
<p style="text-indent: 50px">
“Alright.”  Allyson muttered, staring in the direction of Niveal’s town square.  “Let’s see what you 
are hiding.”  She started walking down the street, taking in the sights and sounds of Niveal.  Allyson 
was a pro at casing locations.  Her mind was recording everything she saw, heard, and smelled as she 
walked, making sure not to look around.  Nothing screamed tourist like walking around staring at 
everything.</p>
<p style="text-indent: 50px">
Allyson made it a few blocks before she noticed a dark blue SUV following her.  The license plate 
was custom and read GEN3T1X.  Allyson needed to find somewhere to lie low until the threat 
passed.  Her strawberry blond hair didn’t stand out in Niveal.  There were people with all kinds of 
hair and eye color.  Her leather jacket and denim pants were also normal, she noticed.  The only 
explanation for the van tailing her was that Allyson was recognized as a newcomer.  She had to 
lose the SUV before going anywhere or doing anything. </p>
<p style="text-indent: 50px">
At a red light, Allyson pulled out the burner phone and looked up restaurants in the area.  There 
was a shopping district just a few blocks away.  The close quarter buildings had narrow alleyways and 
one way streets.  Allyson could lose the SUV there and hide in a café.  After memorizing the street 
names, Allyson shoved the burner phone in her pocket and crossed the street.  As expected, the SUV 
followed.  She turned left.  The SUV turned left.  There was no doubt about it.  Someone was following 
her. </p>
<p style="text-indent: 50px">
“Geez.”  Allyson scoffed, turning into an alley and jogging.  “You’d think they would be a little 
less obvious.”  Allyson turned the corner onto a one way street and ducked into a small dive bar.  It 
was empty aside from three others sitting together and whispering. </p>
<p style="text-indent: 50px">
“Welcome!  Have a seat anywhere you like.”  The bartender said.  Allyson nodded and took a seat in a 
booth away from the group.  The menu was sitting on the table.  Allyson held it up, peeking over the 
top at the SUV.  It drove by quickly and didn’t stop.  She had lost her tail. </p>
<p style="text-indent: 50px">
The dive bar had a weird smell, like rotting fruit.  It turned her stomach, but it didn't matter.  
She wasn’t going to order anything.  It would be rude to just leave the restuarant and not to give it 
some time, and Allyson wanted to make sure the van wasn’t circling around.  She took her time and 
looked over the menu to see what this dive bar offered.  Nothing sounded appealing.  From the corner 
of her eye, Allyson spied the group of people in the back get up and approach her.  She sighed and 
set the menu down, freeing her hands in case there was a confrontation.  They hadn’t been in Niveal 
for more than an hour, and she was already feeling the pressure from the locals. </p>
<p style="text-indent: 50px">
“Hey there!”  A woman with long dark hair greeted her.  She slid into the seat across from Allyson.  
“You don’t look familiar.  Are you new to town?”  She asked.  Allyson glanced at the bartender.  He 
had started to walk over, but turned around and walked back to the bar when the strangers approached. </p>
<p style="text-indent: 50px">
“Depends on who’s asking.”  Allyson responded, folding her arms.  Her hand was close enough to her 
gun that she could pull it out if necessary.  She was a fast draw.  The two men accompanying the lady 
both chuckled and smacked each other playfully. </p>
<p style="text-indent: 50px">
“Told you!  She seems powerful!”  One of them said to the other. </p>
<p style="text-indent: 50px">
The woman glared at them and made them shut up.  Allyson noted the exchange.  These were small time 
gangsters.  That much was obvious.  The woman was the leader.  “Allow me to introduce myself.”  The 
woman offered, brushing her black hair over her shoulder.  “My name is Evangelina.”  She said with a 
dubious smile.  Her gaze flickered to the window before resting back on Allyson.  “That vehicle 
belonged to one of the top three.  You would have to be new not to jump at the chance of a lifetime.” </p>
<p style="text-indent: 50px">
“Top three?”  Allyson asked.  Her investigative reporter mode was activated.  She sighed and smiled 
nervously.  These were small timers, so she would appeal to their need to feel superior.  “I don't 
know what you mean.  I am new to town.  Could you maybe…”  She glanced at Evangelina, whose face lit 
up like a Christmas tree. </p>
<p style="text-indent: 50px">
“Of course!”  Evangelina got up, shooing the men aside, before sliding into the booth next to Allyson. 
The men sat on the other side.  “You should take this.  It will keep those vultures away from you.”  
Evangelina said.  She grabbed a pendant from her pocket and slide it on the table to Allyson.  “It’s 
our club’s emblem.”  Allyson picked up the pendant.  It had an image of a dead pig on it with the 
initials <i>DPS</i>.  She eyed it suspiciously before pretending to be grateful and thanking 
Evangelina. </p>
<p style="text-indent: 50px">
“Thanks.”  Allyson said as they all snickered.  “But tell me.”  She stuffed the pendant in her pocket, 
entering her journalist mindset.  “Who are the top three?” </p>
<p style="text-indent: 50px">
“They’re all jerks!”  One of the men said.  “Just because they are powerful, they think they can run 
this town and everyone in it.  It’s not fair!”  The man slammed his fist on the table, making Allyson 
raise an eyebrow.  She resisted the urge to grab her notepad and record her observations. </p>
<p style="text-indent: 50px">
“The top three are referring to the top three clubs in Niveal.”  Evangelina explained.  She looked 
around before continuing.  “They are the top three because they have some of the more powerful and 
influential people in Niveal.” </p>
<p style="text-indent: 50px">
“Really?”  Allyson asked with genuine intrigue.  She thought about the SUV that was following her.  
“So, whoever was in that vehicle, was one of the most powerful people in Niveal.”  Her mind flashed to 
the picture of Dolores.  If they were powerful, they might know what happened to Dolores. </p>
<p style="text-indent: 50px">
“And one of the worst!”  The other man said.  “That SUV belonged to the notorious…” He dropped his 
voice to a whisper.  Allyson leaned in on impulse.  “<i>DNA</i>.”  The man said. </p>
<p style="text-indent: 50px">
“<i>DNA</i>?”  Allyson asked.  The others all shushed her. </p>
<p style="text-indent: 50px">
“Be careful saying that out loud, Shit!”  Evangelina muttered.  “If they come after us, they could 
crush our club like it was a fly on the wall.”  Allyson was intrigued. </p>
<p style="text-indent: 50px">
“It’s one of the clubs from the university.”  One of the men explained.  “Just because they are 
smart doesn’t mean they are better than everyone.”  The other man smacked him in the back of the head. </p>
<p style="text-indent: 50px">
“One of the clubs?  That means there are more?”  Allyson asked.  This was a strong lead!  None of the 
members of <i>DPS</i> showed any sign of being professional.  None of them had weapons.  They were 
talking freely in front of the bartender, unaware that he was listening to everything that was said.  
Allyson patted her chin.  If she was going to find out what happened to Dolores, there was a strong 
chance that the clubs in the university would know. </p>
<p style="text-indent: 50px">
“Enough!”  Evangelina shushed her club mates.  “Now that we have…”  She glanced at Allyson.  “What 
was your name again?” </p>
<p style="text-indent: 50px">
Allyson chuckled and introduced herself.  “I’m Allyson.  It’s nice to meet you.” </p>
<p style="text-indent: 50px">
“Now that we have Allyson, we can participate in the mixer tomorrow!”  Evangelina beamed.  She 
addressed Allyson.  “Only clubs with four or more members can reserve a table at the mixer.  That’s 
where you can negotiate with the other clubs!”  Evangelina held her fists up.  “We can finally join!  
The event is tomorrow at 1pm.  Are you free to make it?”  Allyson tapped her chin again, pretending 
to think about it. </p>
<p style="text-indent: 50px">
Evangelina was talking about the event called The Niveal Career Showcase.  It was advertised as an 
event where younger people could speak with industry professionals to learn about different careers.  
Reporters from The Empire have covered it before, but none of them ever reported that the event was 
to allow gangs to collaborate.  This was new information that would make a great story.  Allyson had 
to know more.</p>
<p style="text-indent: 50px">
“When you say negotiate, what do you mean?”  Allyson asked.  She moved her hand to grab her notepad, 
but played it off as brushing off her jacket.  The last team that was sent to report on the events in 
Niveal were killed.  Allyson had heard about it, even though it wasn’t publicized.  She didn't want 
Cealen to worry, so she kept that information to herself. </p>
<p style="text-indent: 50px">
Evangelina glanced at the window nervously.  “It’s pretty much who takes first prize at the weekly 
fairs and events, being nice during Niveal dances, and carving out dedicated territory for our club to 
operate in peace.”  She explained without looking at Allyson.  “We should head back to the clubhouse.  
We can talk more there.”  She nodded to her accomplices.  “It’s not safe here.” </p>
<p style="text-indent: 50px">
Allyson looked around.  She didn't see anyone outside.  The bartender was watching, but he wasn’t 
acting suspicious.  “Ok.”  Allyson answered when they all got up.  “I have plans later, but I could 
hang out for a little while.” </p><br>
<p style="text-indent: 50px">
Back at the motel, Cealen finished setting everything up and checked his phone.  Allyson hadn’t 
messaged him, but it was still early.  She had only been gone for two hours.  He wondered if she had 
discovered anything interesting yet.  Allyson was an ace at digging up all kinds of secrets.  He sighed 
and shrugged his shoulders.  Now that things were settled at the motel, he had his part to play.  Cealen 
threw on his sports jacket and walked out.  He needed to get groceries from the store around the 
corner. </p>
<p style="text-indent: 50px">
The bell chimed above when Cealen walked in.  It was quiet, and Cealen liked that.  He had been on 
assignments with Allyson before and knew her tastes.  He shopped the aisles, humming peacefully to 
himself.  Cealen grabbed some premade sandwiches from the refrigerated section.  The selection was 
nice for being a small grocer, and he was impressed with the pricing.  After dropping four sandwiches 
in his basket, he picked up two iced teas.  That would be their lunch when Allyson returned.  He added 
a few different kinds of snacks to his basket and a family sized package of cookies.  Allyson loved 
cookies, and he knew it would help her relax if she encountered some of the gangs. </p>
<p style="text-indent: 50px">
The bell chimed above the front door as a rowdy group entered.  Cealen made sure to keep his distance.
When he was done gathering the basics for a late lunch and dinner for tonight, he headed to the alcohol
section.  He grabbed some beer for himself and Allyson.  It was a long drive, and they could both use 
something to take the edge off.  As he turned down an aisle to head to the cashier, someone bumped 
him from behind.  Cealen dropped the basket and stumbled forward.  Panic shot through his veins. </p>
<p style="text-indent: 50px">
“Oh, shit!  Sorry about that!”  A young man said.  Cealen braced himself on against a rack with chips.  
He wouldn’t hesitate to bail, abandoning the groceries on the floor.  Allyson would understand.  She 
always did.  He wasn’t used to being in the field and was terrified of being killed.  This kind of 
encounter terrified him down to his soul. </p>
<p style="text-indent: 50px">
“I-I’m sorry.”  Cealen muttered without looking back.  He expected shouting and threats.  This was 
Niveal, full of gangs and crime.  One minor offense could lead to bloodshed in the streets for days!  
He read plenty of news stories of murder in Niveal that fueled his fear.  “Don’t worry about it.  
It was my fault.”  Cealen offered to appease the locals. </p>
<p style="text-indent: 50px">
“What?”  A female laughed.  “You must be new here.  That was our fault for bumping into you.  Sorry 
about that.”  The woman said.  When Cealen peeked over his shoulder, he saw a young man with bright 
auburn hair and a young woman with short black hair.  She shrugged her shoulders at him as the young 
man picked up the basket. </p>
<p style="text-indent: 50px">
“Sorry about that.  You dropped your basket.”  The man said.  He handed the basket to Cealen.  “My 
friend wasn't looking where she was going.”  He laughed and nudged the young woman.  "Like always"</p>
<p style="text-indent: 50px">
“You can say that again.”  Another guy said, walking around the corner with a case of beer in his 
hands.  “She never does!”  He laughed.  He had short red hair that stuck out in every direction.  
Cealen relaxed and let out his breath.  These weren't scary gangsters, ready to murder him.  These 
were just citizens of Niveal. </p>
<p style="text-indent: 50px">
“Thank you.”  Cealen stammered.  He was still nervous, but not because he was afraid for his life.  
“My name is Cealen.  I am new here, actually.”  He admitted.  It would be useless to lie, and Cealen 
wasn’t as great at crafting lies as Allyson was. Truth was what he excelled at.</p>
<p style="text-indent: 50px">
“Nice to meet you, Cealen.”  The young man said, handing him the basket.  “I’m Antares, and these are 
my friends, Mint.”  He gestured to the young woman.  “And Liam.”  The guy holding the case of beer 
nodded.  Cealen nodded to each one in turn.  This wasn’t was bad as he first thought, but Cealen still 
had to stay on his toes. </p>
<p style="text-indent: 50px">
“Nice to meet all of you.”  Cealen said.  “I should really-,” before he could finish his excuse to 
leave, his phone chirped.  It was Allyson.  Cealen’s face paled.  “Excuse me.”  He told Antares and 
his friends.  When he pulled out his phone, he saw the message.  Allyson sent a quick message that she 
had discovered a lead on Dolores.  Cealen sighed and started to chuckle to himself.  Of course, 
Allyson was already on the trail. </p>
<p style="text-indent: 50px">
“Is that your girlfriend?”  Mint asked playfully.  “I know that goofy smile.” </p>
<p style="text-indent: 50px">
“What?”  Cealen glanced up at her, stuffing his phone back in his pocket.  “No, no.  You 
misunderstand.  Allyson and I are just partners.”  He said, not realizing how it sounded. </p>
<p style="text-indent: 50px">
“Is she cute?”  Liam asked with a smile.  “Allyson is a pretty name.” </p>
<p style="text-indent: 50px">
“Girlfriend, life partner, whatever.  We don't judge.”  Mint laughed.  “I take it you are both 
new here, then?” </p>
<p style="text-indent: 50px">
“Guys, come on.”  Antares scoffed as they made their way to the front counter.  “Leave him be!  What 
they are is none of our business.”  He lectured.  Cealen chuckled at their antics.  He was glad they 
were kind and not trying to rob him.  A new headline started to form in his head.  For the first 
issue of their time in Niveal, Cealen would write about how warm and welcoming the citizens were.  
For all the horror stories in Niveal, it would be a change of pace to write about how nicely newcomers 
were treated. </p>
<p style="text-indent: 50px">
The group allowed Cealen to go first and check out his groceries.  While the cashier rang the goods 
up, Cealen couldn't help but listen in on their talk.  “Are you sure you don’t want to join us, my 
brother?”  Liam asked Antares.  He set the case of beer on the counter behind Cealen’s stuff.  
“You’re going to miss out.” </p>
<p style="text-indent: 50px">
“I’m sure.  We have the mixer tomorrow anyway, remember?”  Antares said with a chuckle.  “I don't 
enjoy drinking like the rest of you.”  Mint and Liam groaned and joked around with Antares.  They 
respected his choice, but still tried to convince him to come over to their place.  While they were 
palling around, a flash of silver caught Cealen’s eye.  Antares had a silver pin fixed to the collar 
of his jacket that Cealen didn’t notice until now.  It was small and had a depiction of a human eye 
with the letters <i>EYE</i> on it.  Cealen glanced at Mint and Liam.  They each had pins on their 
jackets too.  Their pins matched, having a depiction of a rose with the letters <i>SRS</i>.</p>
<p style="text-indent: 50px">
“That will be $35.87.”  The cashier told Cealen, breaking his train of thoughts.  “Do you have a 
club card?”  Cealen pulled out his wallet as the cashier bagged his stuff.  On assignment, Allyson and 
Cealen used cash.  He pulled out two twenty dollar bills to pay. </p>
<p style="text-indent: 50px">
“Here you are.”  Cealen said, offering the money.  Normally, grocery stores had club memberships that 
offered discounts.  He shook his head at the other question.  “As far as the club card, I-,” Cealen 
started before Antares stepped in. </p>
<p style="text-indent: 50px">
“He does.”  Antares said nervously.  He pulled out his wallet and offered the cashier a plastic card 
with the same human eye symbol on it with the letters <i>EYE</i>.  “He’s with me.”  Antares stated.  
Cealen was caught off guard by the tone.  He glanced at Antares and saw the young man looking 
serious.  A chill ran down his spine.  These were nice locals, but that didn't mean they weren’t part 
of a gang.  The cashier paled and nodded. </p>
<p style="text-indent: 50px">
“Right!  Sorry…”  The cashier said, accepting the cash that Cealen offered.  “My apologies, Antares.”  
Cealen raised his eyebrows as Mint and Liam chuckled behind them.  Antares shrugged his shoulders at 
the look Cealen had and palmed a silver pin into Cealen’s hand. </p>
<p style="text-indent: 50px">
“You should really wear your pin, Cealen.”  Antares said, elbowing Cealen playful.  “It will help keep 
you out of trouble, for the most part.”  Antares laughed.  Cealen blinked his eyes in confusion as he 
stared at the silver pin in his hand.  He wasn’t a field reporter and didn't understand why Antares 
said that.  Cealen glanced from the cashier to Antares.  He was completely oblivious to how Antares 
saved him.  Mint and Liam laughed harder. </p>
<p style="text-indent: 50px">
“Maybe you both should come back to our place to party.”  Mint said, nudging Cealen and Antares to 
move out of the way.  “We can talk more back at the <i>SRS</i> house.”  Mint offered.  Cealen started 
to sweat.  Now that he noticed their pins, he saw the cashier had one too.  Acting as a cuff link, the 
cashier had a silver pin with an engraving of a throne on it.  The initials on it were <i>TWD</i>.  
Cealen grabbed his bags and the receipt.  He had to get out of there! </p>
<p style="text-indent: 50px">
“Thanks for the offer, but I must be going.”  Cealen said to the others.  He needed to return to their 
motel and tell Allyson about this!  Antares walked with him to the door as Mint and Liam checked out.  
Antares held the door open as the bell chimed above.  Cealen tried to hand the pin back to Antares, 
but the young man refused.  “I appreciate what you did back there, but I can’t accept this!”  Cealen 
whispered.  He held the silver pin out to Antares.  “Please!”  Cealen begged, looking around.  “I 
can’t take this.”  He wanted no part of being in a gang! </p>
<p style="text-indent: 50px">
“Trust me.”  Antares reassured Cealen.  He offered the nervous Cealen a friendly smile.  “You seem 
like a nice guy, and I wouldn’t want anything to happen to you or your partner while you were.”  
Antares leaned his back against the door, holding it open.  He shoved his hands in his pocket.  “Niveal 
is all about clubs, and my club is pretty popular.”  Antares said as color bloomed in his cheeks.  
“Nobody will question you if they see that.”  He chuckled.  Cealen huffed out his frustration.  This 
was a gang, and Cealen wanted no part in it. </p>
<p style="text-indent: 50px">
“I just… I don’t want to…”  Cealen struggled to find a way to say he didn’t want to be a part of a 
gang without sounding rude.  Gangsters were mean and territorial.  They forced their members to patrol 
their territories, harass other gangs, and commit all manner of crime.  Allyson and Cealen just 
arrived in Niveal, and already, Cealen was in over his head.  He stared at Antares with his most 
pleading look.  “I’m not looking for any kind of social commitment.”  Cealen finally said.  That was 
the nicest way he could think of to refuse being in the <i>EYE</i> gang. </p>
<p style="text-indent: 50px">
“Oh, don’t worry about it.”  Antares waved his concern aside as Mint and Liam paid for the beer and 
headed their way.  “There are no strings attached.  Even if we don’t see each other again, that will 
help keep you and your partner safe in Niveal.”  Antares said.  He pointed at the pin Cealen held in 
his hand.  “You don’t have to say anything to anyone.  Just wear that so it can be seen, and no one 
will bother you.”  He sighed and offered Cealen a genuine smile.  “Not everyone in Niveal is bad, you 
know.  There are a few of us that are good.”  Liam let out a loud burst of laughter.  Mint stopped 
walking and playfully punched his arm.  The antics made Cealen and Antares chuckle.  “They’re good 
people too.”  Antares said, nodding to Mint and Liam. "You'll see."</p>
<p style="text-indent: 50px">
Cealen rubbed the face of the silver pin with his thumb.  It was a gamble to hold onto something that 
was gang affiliated, but he wanted to believe Antares.  “It would be a waste on me.”  Cealen tried to 
reason.  “Especially if we don’t cross paths from here on out.”  It was his last effort to get rid of 
the pin.  Part of him wanted to keep a hold of it.  He wanted to show Allyson.  If she found a lead on 
Dolores, being connected with EYE might help her.  The other part of him wanted to ditch it.  </p>
<p style="text-indent: 50px">
“If it helps you and your partner stay safe while you are here in Niveal,” Antares answered with an 
easy smile.  “Then it’s not a waste.  <i>EYE</i> is here to help anyone that needs it.”  He said, 
opening the door wider for Mint and Liam. </p>
<p style="text-indent: 50px">
“Thank you, my friend.”  Cealen sighed, finally submitting.  He stuffed the pin in his pocket.  “I 
will do as you say.”  Cealen nodded and moved out of the way so Mint and Liam could exit the store. </p>
<p style="text-indent: 50px">
“Bring your girlfriend next time, Cealen.”  Mint said, patting him hard on the shoulder.  “If she 
hasn’t joined a club yet, she can join <i>SRS</i>.”  Mint fished in her pocket and pulled out a pin 
with a silver rose.  “I can’t let Antares steal both of you!”  The group laughed and waved their 
farewells to Cealen.  Cealen stood next to the grocery store as he watched them leave.  Antares helped 
him out of a tight spot without expecting anything in return.  That wasn’t typical of gangsters in 
Niveal.  This was new intel that he collected first hand. </p>
<p style="text-indent: 50px">
A smile worked itself on Cealen’s face.  He wasn't a field man, but he knew this was going to help.  
Allyson would be proud.  As he walked back to their motel, Cealen fished out the silver <i>EYE</i> pin. 
He stared at it, wondering what being in the <i>EYE</i> gang would be like.  Just as he turned the 
corner to head for the stairs of the motel, a woman in a leather jacket came rushing down.  Cealen 
didn't have time to move out of the way, and the two collided. </p>
<p style="text-indent: 50px">
“I’m so sorry, miss!”  Cealen uttered immediately.  The silver pin tumbled out of his hand and hit the 
sidewalk, ringing until it came to a stop with the human eye image facing up.  The woman hesitated in 
her get away, glancing back at the silver pin on the ground.  Cealen sucked in his breath as he looked 
up at her.  She was hiding her face under a black hoodie that she wore under her leather jacket.  Fire 
red hair spilled out, hiding the woman’s expression.  The woman was wearing too many layers for this 
time of year!  She was a gangster! </p>
<p style="text-indent: 50px">
The woman didn't say anything as she glanced from the pin to Cealen.  He held his breath.  Her jacket 
was open, and Cealen didn't miss her leather gun holsters under each arm.  He didn't dare make a 
move.  On the breast pocket of the jacket, proudly displayed, was a silver pin with a phoenix sigil.  
Cealen couldn't make out the letters that were underneath from his distance. </p>
<p style="text-indent: 50px">
“Get the hell out of here, you vultures!”  A woman shouted from the lobby of the hotel.  “How dare you 
come around here!”  The woman stepped out of the doorway with a rifle.  Cealen’s heart started to race.  
This was what he expected from the gangs in Niveal!  He didn't notice the receptionist had a rifle 
when they checked in!  “Beat it!  Nobody around here wants to join your club!”  The woman shouted, 
raising the rifle. </p>
<p style="text-indent: 50px">
In a flash, the strange woman with a phoenix pin climbed on a motorcycle that was waiting at the end 
of the parking lot.  Someone handed her a helmet before they drove off together.  Cealen held his hand 
to his chest and waited for his heart to slow down.  This was Allyson’s thing, not his. </p>
`,
          isAvailable: true, // Set to false to hide it
        },
        {
          id: 'chapter-2',
          chapterNumber: 2,
          title: 'Making Friends',
          content: `<p style="text-indent: 50px">
          Later, after Allyson returned, Cealen told her about what happened as they ate.  He mentioned 
          the group of people he ran into and showed her the strange silver pin.  “Wow!  Nice work, 
          Ceals!”  Allyson said as she inspected the silver pin Cealen showed her.  She ran her finger 
          over the eye sigil.  “So this Antares guy,”  She glanced over at Cealen.  “Is he the leader of 
          <i>EYE</i> then?  Only leaders are allowed to pass out these pins.”  Allyson said.  She sipped 
          her beer as she sat on her bed with her legs crossed.  Allyson had taken a lot of notes on 
          what happened and about everything Evangelina shared with her.  She tapped the rim of the beer 
          bottle against her chin.  “I think <i>EYE</i> is one of the larger clubs in Niveal.  I saw a 
          few of them around today.”  Allyson reached over and handed Cealen the pin.  “Nice work, field 
          agent.”  She teased with a grin.  “Color me impressed!” </p>
<p style="text-indent: 50px">          
Cealen nearly choked on his beer.  “Don’t even joke!  I have no idea if that nice young man is the 
leader or not.  He looked like a teenager, for God’s sake.  I didn’t ask.”  He shook his head and 
sighed.  “I didn’t want to!”  He admitted, taking the pin and setting it down on the night stand next 
to his bed. </p>
<p style="text-indent: 50px">
After they ate, they both relaxed on their beds as the sun set.  Allyson shared everything that 
happened to her, from the van following her to joining a small club.  Now that they were settled, it 
was the time to strategize about what to do next.  “Have you learned the lay of the land, then?”  Cealen 
asked to change the subject.  “What was the lead you found on Dolores?” </p>
<p style="text-indent: 50px">
Allyson picked up her notepad and flipped through her notes.  “Oh, for sure.”  She set her beer down.  
It was time to focus and make their next move.  “The city is run by three main clubs, all with the 
mayor in their pocket.  Two of them have their headquarters in the university!  Everyone is afraid of 
them, especially smaller clubs.”  She glanced at Cealen with a knowing grin.  “They will be my first 
target.”  Allyson could sense she was on to something, and Cealen didn’t have to ask.  He trusted her 
intuition. </p>
<p style="text-indent: 50px">
“Nice!”  Cealen muttered.  He scooted closer toward her, snacking on the chips.  “So you think Dolores 
could have been taken by one of those clubs?”  Cealen asked.  Allyson shook her head no. </p>
<p style="text-indent: 50px">
“I think Dolores was a part of one of those clubs.”  Allyson told him.  “The clubs are aggressive 
about recruiting members, especially the top three.”  Her gaze shifted to the silver pin on the night 
stand.  “Just look at you!  Your friend Antares was right.  If you don't have something to indicate 
you are part of a club, they literally stalk you!” </p>
<p style="text-indent: 50px">
Cealen took a deep breath.  Memories of his encounter with Antares and Mint didn’t give him the 
impression that they were bad.  They didn't seem to stalk him.  Cealen ran into them because they were 
stocking up for a party.  “At least <i>EYE</i> doesn’t seem like a bad gang.  Neither was the other 
one.  They were nice and were just there to get things for a party.”  He muttered, glancing at 
Allyson.  “What about the one you joined?” </p>
<p style="text-indent: 50px">
“Oh,”  Allyson huffed out a laugh and grabbed her beer.  “<i>DPS</i> is a small, amateur gang.  They 
only have four people, including me.”  Allyson told him.  She shrugged her shoulders when Cealen 
raised his eyebrow at her.  “That doesn’t matter, though.  I was told the mixer tomorrow would have 
all the clubs in attendance.”  She tilted her head to Cealen.  “I’m sure <i>EYE</i> will be there.  
Want to go with me?”  She offered.  Allyson already knew his answer.  Cealen shook his head no 
immediately.  After what he experienced today, he didn't want to step foot outside if he didn't have 
to. </p>
<p style="text-indent: 50px">
“No, thanks!”  Cealen said, holding up his hands.  “I’ll wait for your report.” </p>
<p style="text-indent: 50px">
“Suit yourself.”  Allyson laughed.  She grabbed her notepad again.  “The two clubs associated with 
Niveal University are <i>ROC</i> and <i>DNA</i>.”  Allyson reported.  She pursed her lips.  “It was 
a <i>DNA</i> van that was following me around today.  They must be a bigger club.  I doubt they will 
be deterred by this.”  Allyson said, picking up her silver <i>DPS</i> pin.  “Rumors have it that the 
big clubs even steal the members of smaller ones.  During the mixer tomorrow, I will try and get 
some info on those two university clubs.”  The subject was sobering.  “If Dolores was a part of one 
of them, that’s where I will start looking.”  This was going to be dangerous for both of them if 
they had to tango with the big gangs of Niveal.  Neither one of them expected that.  After a moment 
of silence, Cealen glanced over at Allyson. </p>
<p style="text-indent: 50px">
“Do you know if they part of the top three?”  Cealen asked.  “The university clubs, I mean.”  The 
memory of the red haired woman with a phoenix pin flashed in his mind.  He had forgotten to tell 
Allyson about his encounter with her and her motorcycle get away driver.  Allyson picked up that 
something was being left unsaid.  After tidying up the room, and double-checking all the security 
precautions, she climbed back into her bed. </p>
<p style="text-indent: 50px">
“I believe so.  It would be odd if a college town like Niveal didn't have university clubs in the 
top three.”  Allyson said.  The logic was undeniable.  She dove under the covers as she faced 
Cealen.  “Why do you ask?  <i>EYE</i> might be one.  Do you think that other one might be as well?”  
Cealen sighed and tucked himself in. </p>
<p style="text-indent: 50px">
“No.”  He said through a yawn.  “I met someone else today.”  Cealen chuckled.  “Well, if you could 
call that a meeting.”  He glanced over at her.  “She was at the motel.  A woman with a phoenix on 
her pin.”  Allyson closed her eyes as she went over all the club pins she saw today.  There were some 
<i>EYE</i> pins, <i>SOF</i> pins, <i>SUC</i> pins, and <i>TWD</i> pins.  None of them had a phoenix 
on the front. </p>
<p style="text-indent: 50px">
“Did you see what the club initials were?”  Allyson asked. </p>
<p style="text-indent: 50px">
“No…  She was being chased off by the motel staff.”  Cealen responded.  He was feeling the pull of 
sleep.  “Maybe they will also be at the mixer tomorrow.”  Allyson giggled at his statement. </p>
<p style="text-indent: 50px">
“Maybe.  What did this mysterious woman look like?”  Allyson probed. </p>
<p style="text-indent: 50px">
“Beautiful.”  Cealen answer without thinking.  “I mean…!”  He groaned and rubbed his face.  “You 
know what I mean… A nice lady.”  They both laughed about Cealen’s encounter until they fell asleep.  
Their plan was set.  In the morning, Cealen would research the clubs at the university through the 
school’s website and social media channels.  Allyson would attend the mixer.  It was only their first 
day, and they were already hot on the trail. </p><br>

<p style="text-indent: 50px">
“We’re finally here!”  Evangelina beamed.  “The club mixer!  We finally have enough members to 
attend!”  She bounced on her heals as Allyson looked around the venue.  The Niveal Career Showcase 
was a huge event and was held in Niveal’s convention center.  It was packed with people and reminded 
Allyson of video game conventions.  Everyone had badges either clipped to their shirt or around their 
neck on lanyards.  In the top center of the badge, above the individual's name, was the club 
affiliation.  She laughed as she glanced around at all the badges.  The gangs of Niveal were not shy 
about their presence.  Maybe Cealen was right, Allyson thought.  They would find Dolores in no time 
if she was associated with one of these clubs. </p>
<p style="text-indent: 50px">
“What now?”  Allyson asked as they walked in wearing their badges.  The convention center was filled 
with murmurs and people.  There was a giant lobby, where people were milling about, chatting with 
each other while they purchased food and drinks.  Allyson was recording everything in her mind.  Her 
task for the day was to ditch Evangelina and the members of <i>DPS</i>, while she hunted for <i>ROC</i> 
and <i>DNA</i> members.  Their badges were everywhere, but Allyson noticed they stayed in groups.  
Approaching them without drawing suspicion was going to be difficult. </p>
<p style="text-indent: 50px">
“Now!”  Evangelina held up a blue card that she received with her badge.  “Let's go set up our 
table!”  She squealed.  Evangelina hooked her arm with Allyson’s, causing Allyson to tense.  She was 
wearing her shoulder holster under a black balero jacket.  Since this was a formal event, Allyson was 
wearing a dark blue dress with a circle skirt.  She wore black boots that held a knife, and a balero 
jacket that hid her pistol.  Since Allyson was going to be surrounded by gangs, she needed to be 
prepared.  Her burner phone was in the small, simple purse that she wore over her shoulder.  She 
didn't bring anything except the burner phone and her motel key card.  Allyson slid her hand over 
her pistol, keeping Evangelina from noticing it. </p>
<p style="text-indent: 50px">
“Oh… Ok.”  Allyson muttered, letting Evangelina drag her to a giant ballroom full of tables lined up 
in neat rows.  Each table had four seats, and they filled up quickly.  As they walked toward the 
empty tables, Allyson registered who was running each of the tables.  She was an expert people 
watcher and could pick up subtle behavior clues that provided insight into the person.  <i>ROC</i> 
and <i>DNA</i> ladies were hosting many of the tables.  As expected, they were smiling and waving 
people over.  The girls of <i>ROC</i> were wearing sorority sweaters.  The girls from <i>DNA</i> were 
wearing matching prep academy style school uniforms.  They were the ones associated with the 
university and were her primary targets.  Allyson had to get a seat at one of those tables.</p>
<p style="text-indent: 50px">
Along with <i>ROC</i> and <i>DNA</i>, Allyson spied other tables with <i>SRS</i>, <i>EYE</i>,
and <i>SUC</i> hosts.  All the gangs had showed up for the Career Showcase, Allyson mused.  She made
a mental not to visit the other gangs too.  Cealen spoke well of them, and Allyson was curious.  Her 
step faltered when she glimpsed a few tables with hosts from <i>FNX</i>.  Their badges had the 
phoenix sigil that Cealen described. </p>
<p style="text-indent: 50px">
“Allyson!”  Evangelina hissed through her teeth.  “Be careful not to stare at those guys!”  Her 
tone was heavy with worry, making Allyson glance down at her. </p>
<p style="text-indent: 50px">
“What?”  Allyson asked.  “You mean the <i>FNX</i> people?” </p>
<p style="text-indent: 50px">
“Shhh!”  Scolded one of the other members of their club.  “Dude!  They are one of the meanest and 
most powerful clubs in all of Niveal.” </p>
<p style="text-indent: 50px">
“You mean THEE most powerful.”  The last member whispered, smacking the other one in the back of 
the head.  “Don’t let them hear you talking shit.”  He chuckled.  Allyson nodded and tried to 
hide her glances their way.  Unlike the other tables, the people sitting at <i>FNX</i> tables were 
smiling and laughing.  They were also keeping an eye on the passing crowd without making it obvious.  
Allyson took a breath and surveyed a few of the people.  She marked at least two of them concealing 
weapons.  The members of <i>DPS</i> were right.  They were no small time gangsters.  <i>FNX</i> was 
the real deal mafia type of gang. <p>
<p style="text-indent: 50px">
“Here we are!”  Evangelina beamed.  Before Allyson looked away, she locked eyes with a woman sitting 
at the <i>FNX</i> table.  She wore a leather jacket and had curly brown hair.  The woman only smiled 
back at her, sending a chill down Allyson’s spine.  She wasn’t looking at Allyson with fear or 
suspicion like others were.  The woman was looking at Allyson with intrigue.  It wasn’t long before 
the rest of the people at the table glanced her way.  Allyson immediately turned her back to the 
<i>FNX</i> crowd.  If they were the top gang in Niveal, she had to be careful and not pose as a 
threat.  The last reporters from The Empire were killed by a top gang.  The report never mentioned 
who it was, but as the most powerful gang in Niveal, it could have been <i>FNX</i>. </p>
<p style="text-indent: 50px">
“Yeah!  Great!”  Allyson said, taking a seat.  She kept her back to the other tables.  “Now what?”  
She drummed her knuckles on the table.  Now that she was here, Allyson was more nervous than she 
thought she would be.  Staying alert in this environment was exhausting. </p>
<p style="text-indent: 50px">
Evangelina sat down in the host seat after passing the blue card to a convention center staff 
member.  “Now, we wait!”  She sighed a dreamy sigh as she reached in her bag and set papers and 
flyers for <i>DPS</i> on her table.  “Soon, others will come and want to have a seat.  Feel free to 
browse around.  This is neutral territory.”  She explained through a whisper.  The other two members 
nodded and walked off.  Allyson was hesitant to get up. </p>
<p style="text-indent: 50px">
“What do you mean?”  Allyson asked.  The back of her neck was burning.  Someone was watching her.  
When she took the chance to glance at the <i>FNX</i> table, she noticed none of them were looking at 
her.  It wasn’t the woman with curly brown hair preying on her.  She took a breath and faced 
Evangelina.  If she stayed at the table, trouble might show up.  Getting into a fight with another 
gang at such a public event could ruin the connections she made with <i>DPS</i>.  Her chances of 
attending more club events would be in jeopardy.  This was her ticket into the gang underground, and 
she wasn’t about to give it up.  Allyson entered her spy mode. </p>
<p style="text-indent: 50px">
“I mean, feel free to go and visit other tables!  We were only allowed in this room because of you.  
This is our chance to talk to the big clubs and make alliances with them.”  Evangelina explained as 
she straightened her material.  “I have to stay here and talk with anyone that shows up.”  Her eyes 
skimmed over the people walking behind Allyson.  Allyson watched the optimism dim in Evangelina’s 
eyes.  <i>DPS</i> was desperate for others to join, and it showed on Evangelina’s face and in her 
body language.  </p>
<p style="text-indent: 50px">
“Ok.”  Allyson said, standing up.  An idea whispered to her.  “Who are the big clubs I should talk 
too?”  She glanced to the left and saw a gaggle of sorority girls.  One of them stood up and walked 
away, leaving an empty seat at the table.  “How about <i>ROC</i>?”  Allyson offered. </p>
<p style="text-indent: 50px">
“Perfect!”  Evangelina clapped her hands.  “If you could talk to them, maybe we could merge our 
clubs!”  Evangelina’s eyes darted around.  She was cooking up all kinds of madness that Allyson 
didn’t understand.  “Yes!  If you could make connections with <i>ROC</i>, they are the third most 
powerful club!”  Allyson nodded her head.  That was all she needed to hear.  If <i>FNX</i> was at 
the top of the ranking, and <i>ROC</i> was third, then she suspected <i>DNA</i> was second. </p>
<p style="text-indent: 50px">
“Alright!  I’ll let you know what they say.”  Allyson said before getting up and walking over to 
the <i>ROC</i> table.  The woman at the host seat had a warm smile and a dozen brochures in front 
of her.  The name on her badge displayed Aurelie.  “Hello!”  Allyson greeted, taking a seat.  “May 
I have a brochure?”  She asked with a smile.  Aurelie gritted her teeth as she hesitantly slid a 
brochure across the table to Allyson.  Instead of the friendly welcome Allyson was expecting, she 
was greeted with hostility. </p>
<p style="text-indent: 50px">
“Who do you think you are?”  Said the girl sitting next to Allyson.  The pink sorority sweater looked 
two sizes too small.  The name on her badge was Haelin.  “This is an <i>ROC</i> table.  Get lost.”  
She muttered, waving her hand dismissively. </p>
<p style="text-indent: 50px">
“Haelin!”  Aurelie lectured.  She offered Allyson a nervous smile.  “Here is our brochure.  Our club 
is <i>ROC</i>.”  She said, pointing to the sigil of swords forming an X.  “We are Rho Omega Cappa at 
the university.  Most of our members are students.  Are you a student,” Aruelie’s eyes dipped to 
Allyson’s badge, “Allyson?”  The kind woman asked. </p>
<p style="text-indent: 50px">
Allyson was hesitant to respond.  She didn't want to tell one of the top three gangs that she was 
new in town, or a reporter.  Just as she was about to say something, Haelin slid her chair back and 
stood up. </p>
<p style="text-indent: 50px">
“This is an <i>ROC</i> table, meaning only <i>ROC</i> sorority members or prospective sorority members
are allowed to sit here.”  Haelin huffed in frustration.  Her too small sweater was pulling against 
the hard foam cups of her push-up bra.  The caked on makeup wrinkled from the scowl she gave Allyson.  
“Leave, now!”  Haelin demand.  Allyson glanced around.  Haelin was raising her voice, making a scene.  
Others were starting to look around. </p>
<p style="text-indent: 50px">
“Haelin!  This is a mixer for other clubs.  You know Rabbit said we needed more…” Aurelie whispered, 
glancing over to the right.  Allyson followed her gaze and saw the woman with curly brown hair at the 
<i>FNX</i> table.  “We need more members to be the best club.”  Aurelie finished carefully.  Allyson 
raised her eyebrow at the host.  It was obvious the two were rival gangs.  This was new intel that 
made Allyson’s hands itch.  She wanted to text Cealen with an update, but decided to wait until she 
was alone in the bathroom.  Pulling out her phone in a room surrounded by criminals could get her 
killed. </p>
<p style="text-indent: 50px">
“We don't need bottom feeders who aren’t even enrolled in NU!”  Haelin laughed a menacing laugh and 
grabbed Allyson’s badge.  Allyson tensed.  This was getting dangerous!  “<i>DPS</i>?  Is that even a 
real club?”  Haelin placed a hand on Allyon’s shoulder to push her out of the seat.  “My friend 
Elora was sitting there.  Get out of her-AHHHHH!”  That was all the provocation Allyson was going to 
tolerate.  She stood up, grabbed Haelin’s arm, and attacked.  Everyone gasped around them as Allyson 
twisted Haelin’s arm behind her back and slammed Haelin face-first into the table with a loud thump.  
With her other hand, she pulled her 9mm out and stuck the barrel against Haelin’s cheek.  The noise 
of the mixer died down.  All eyes were on Allyson. </p>
<p style="text-indent: 50px">
The click of the hammer echoed around them.  Allyson’s heart skipped a beat.  It was an automatic 
reaction to a threat.  Now that Allyson was in this situation, she had to manage the fallout.  It was 
bold, but she had to set a precedent.  “Do not put your hands on someone you know nothing about!”  
Allyson said.  She glanced Aurelie.  As expected, Aurelie had a hand under the table.  She maintained 
her calm, but she would not let Allyson walk away if Haelin was harmed.  This was a tricky 
situation. </p>
<p style="text-indent: 50px">
“You bitch!”  Haelin screamed at Allyson.  “Kill her!  What are you waiting for?”  Haelin was 
sweating and shifting on her feet.  She was too afraid to move, so she wanted her <i>ROC</i> sisters 
to help her out. </p>
<p style="text-indent: 50px">
Before Allyson could say anything in response, she felt the barrel of a gun press against her ribs.  
“You are causing quite the disturbance.”  An older woman’s voice whispered in her ear.  “You must be 
new, so allow me to explain the rules.”  The woman’s voice was light, but the echo of a threat was 
there.  “No weapons are allowed at the tables.  These are supposed to be friendly negotiations.”  
Allyson took a breath.  She had to get out of here. </p>
<p style="text-indent: 50px">
Aurelie and the other <i>ROC</i> member at the table relaxed.  Allyson had to buy time until she could
think of a way out of this that didnt leave her in a body bag.  “It’s not very friendly to harass and 
attack someone who approaches the table.”  Allyson responded.  She glanced at the brochure that 
Aurelie had slid over to her.  “I was just getting a brochure.” </p>
<p style="text-indent: 50px">
“She took Elora’s seat!”  Haelin hissed out. </p>
<p style="text-indent: 50px">
“She is new!”  The older woman snapped.  “She doesn't know any better.”  Allyson’s breathing picked 
up as she sensed two others walk up behind her.  She slowly slipped on the safety of her pistol and 
released Haelin.  Whoever this older woman was, she held more standing over the gang than Haelin.  
“You can call me Rabbit.”  The older woman said.  She pulled Allyson away from Haelin.  “Did you have 
any questions regarding my club?”  When Allyson glanced her way, Rabbit nodded to the other <i>ROC</i>
members surrounding them.  They dispersed in the crowd, managing the attention of the room away from 
Allyson and Rabbit.  The low rumble of chatter continued as people started to turn away. </p>
<p style="text-indent: 50px">
“I wasn’t planning on staying at the table.”  Allyson explained.  All her nerves were screaming for 
her to leave.  Rabbit was still holding a gun to Allyson’s ribs.  “I was just-,”  She reached for the 
brochure, but Rabbit grabbed her arm. </p>
<p style="text-indent: 50px">
“No.”  Rabbit said quietly.  “We aren’t interested in new upstarts like you.”  Rabbit whispered.  
“You need to learn your place, and I-,” </p>
<p style="text-indent: 50px">
“There you are!”  Another woman came over with her straight brown hair pulled into a ponytail.  She 
was wearing the same matching uniforms as the <i>DNA</i> people and had giant circular glasses.  “I’m 
glad you could make it, Allyson!”  The woman greeted them with a smile.  “It’s nice to see you 
again.”  Rabbit stowed the gun away but didn't loosen her grip around Allyson’s arm. </p>
<p style="text-indent: 50px">
“You know her, Scholar?”  Rabbit asked.  Allyson glanced at the nerdy female.  Her badge was clipped 
to her vest and had the sigil of a dinosaur with the letters <i>DNA</i>.  This was someone from the 
second most powerful gang in Niveal.  It was interesting to see the members of <i>ROC</i> react to 
her.  Allyson could tell they were all intimidated. </p>
<p style="text-indent: 50px">
“Yes.”  Scholar said with finality.  She adjusted her glasses and forced her way between Allyson 
and Rabbit.  Scholar knew exactly what would happen if she didn’t step in.  There was enough violence 
and bloodshed in the streets these days in Niveal.  She didn't want to see anymore.  “Allyson is a 
friend of mine.”  Scholar stated quietly.  She leaned closer to Rabbit.  “So leave her alone.” </p>
<p style="text-indent: 50px">
Allyson held her breath.  She had never met this woman before.  The badge around Allyson's neck 
advertised her name, so she wasn’t surprised to be addressed on the familiar.  Nevertheless, there 
were four <i>ROC</i> ladies, and Allyson wagered they were all armed. She and her rescuer were out 
numbered.  The studious looking Scholar didn’t have a bag, and her uniform didn't appear to hide any 
weapons.  The effort was appreciated, but Allyson couldn’t image how they were getting away from 
this.</p>
<p style="text-indent: 50px">
Rabbit had silver gray hair and looked like a grandma.  The sorority sweater fit like a glove to her,
and Allyson figured that was on purpose.  Rabbit dressed to impress others.  She was very experienced
and long in the tooth with these gang wars.  The older woman pursed her lips at Scholar.</p>
<p style="text-indent: 50px">
“She threatened one of my members.”  Rabbit whispered back to Scholar.  Despite the smug smile, Rabbit 
was looking around the room nervously.  “Someone needs to put her in her place.” </p>
<p style="text-indent: 50px">
“I will make sure Allyson knows the rules.”  Scholar said before Allyson could answer.  She grabbed 
Allyson’s hand and pulled her away from the table.  The drama addicted spectators lost interest, and 
started to mind their own business.  The tension in the air started to ease, much to Allyson’s 
relief.  She was glad Cealen didn't come to the mixer.  After what happened, Allyson was starting to 
second guess coming herself. </p>
<p style="text-indent: 50px">
It was silent as Scholar and Rabbit faced off.  Haelin started to complain and bitch about Allyson.  
Aurelie welcomed newcomers that passed by, handing them brochures.  “Are you taking responsibility 
for her then?”  Rabbit finally asked.  Allyson tried to pull her hand away from Scholar’s, but the 
feisty university nerd wouldn’t let go. </p>
<p style="text-indent: 50px">
“I will take her to see the Professor.”  Scholar whispered back, adjusting her glasses.  “He is 
waiting for her.”  Another cold chill ran down Allyson’s spine.  It was a <i>DNA</i> van that was 
following her yesterday.  Now, she was about to disappear with one of their members. </p>
<p style="text-indent: 50px">
“I’ll just let my club know.”  Allyson said, trying to pull her hand away again.  Scholar still 
wouldn’t let go.  Neither Scholar nor Rabbit acknowledged her. </p>
<p style="text-indent: 50px">
“Don’t worry about your dumb little club.”  Haelin laughed, turning in her chair to face Allyson.  
“They won’t be far behind you.”  Allyson swallowed back her fear and glanced over at Evangelina’s 
table.  It was surrounded by sorority sweaters.  Evangelina looked panicked as a taller woman forced 
her out of the host chair.  The staff were all turning a blind eye to the situation.  This was it!  
Allyson had to leave, NOW!</p>
<p style="text-indent: 50px">
“Don’t worry, Allyson.”  Scholar said, finally taking her eyes off of Rabbit.  She flashed Allyson a 
suspicious smile.  “You can come with me.”  She glanced at Allyson’s event badge.  “It’s probably for 
the best that you take that off now.”  Scholar started to pull Allyson to the door.  Allyson’s heart 
started to race.  <i>DNA</i> members were all staring at them.  There were two students by the door, 
casually hanging out.  More were watching and pointing at Evangelina.  Allyson’s breathing picked 
up.  She was in over her head and would be lucky to make it out of the event with her life.  After 
taking a deep breath, Allyson made her plan. </p>
<p style="text-indent: 50px">
“Sure.”  Allyson responded, taking off her badge.  She pulled Scholar away from Rabbit and the 
<i>ROC</i> table.  To get out of this situation, Allyson needed to take back control.  “Let’s go.”  
She handed her badge over and followed behind Scholar.  Once she was in the clear, she would call 
Evangelina and make sure the members of <i>DPS</i> were alright. </p>
<p style="text-indent: 50px">
“Great.  Thank you for not fighting me.  Rabbit would have killed you.”  Scholar said without looking 
back at Allyson.  She was rushing for the door to the lobby.  When they passed a trash can, Scholar 
threw Allyson’s badge away.  “Nobody will question you with me by your side.”  A greedy smirk kissed 
her lips.  <i>DNA</i> was close to overpowering <i>FNX</i>.  They only needed a few more strong 
members to take over Niveal completely.  Allyson had the attitude they were looking for, and she was 
a new face to the scene.  That played perfecting into <i>DNA's</i> favor.</p>
<p style="text-indent: 50px">
“That’s… kind of you.”  Allyson answered nervously.  “So… what happens now?”  Scholar was still 
holding on tight.  “Am I joining <i>DNA</i> then?”  She asked.  Scholar huffed out a laugh. </p>
<p style="text-indent: 50px">
“It’s not that simple.”  Scholar answered as they left the ballroom with all the tables.  “First, 
the Professor has to approve.”  The tone she used made Allyson nervous. </p>
<p style="text-indent: 50px">
“Approve?”  Allyson asked.  She wasn’t sure she wanted to meet the Professor guy.  “That sounds…” </p>
<p style="text-indent: 50px">
“Very methodical?  That’s because it is.”  Scholar said, adjusting her glasses.  “Our club is all 
about procedure and protocol.”  She glanced over her shoulder at Allyson.  “We excel at everything 
we do because we are constantly optimizing our approach.”  She continued to ramble on in an astute 
manner, but Allyson couldn't follow her.  Between the superlatives and vague generalizations about 
the club’s activities, Allyson had no idea what <i>DNA</i> was about.  If this was her elevator pitch 
for Allyson to join the club, the academic nerd was failing.  Scholar was only describing what 
Allyson could do to help <i>DNA</i>, not what <i>DNA</i> could offer Allyson.  It wasn't clear how the
other members of <i>DNA</i> benefited from the clubs activities.  Allyson needed better intel.  Maybe 
enrolling in a class or two would give Allyson more face time with Scholar.  Once she got to know her 
better, Allyson would inquire more about <i>DNA</i>. Making a connection was a big break towards finding
what happened to Dolores.</p>
<p style="text-indent: 50px">
“Ok.”  Allyson answered when Scholar looked at her for a response.  She had no idea what the question
was, but her response made Scholar smile.  The answer was sufficient, and Scholar continued to brag 
about her club.  Scholar stopped abruptly, causing Allyson to bump into her. </p>
<p style="text-indent: 50px">
“Shit!”  Scholar muttered.  She adjusted her glasses.  “Wait here.  Looks like Rabbit isn’t giving 
up.”  Allyson sucked in her breath when she glanced at the exit of the convention center.  There were 
two policemen walking in with <i>ROC</i> members in identical sorority sweaters.  Scholar guided 
Allyson to stand beneath stairs that led to conference rooms on the second floor.  “Stay here and 
don’t talk to anyone.”  Scholar said, patting Allyson on the shoulder.  “I’ll go talk to them.” </p>
<p style="text-indent: 50px">
“Wait!”  Allyson grabbed Scholar’s arm.  She didn't have a badge anymore, and people were starting to 
stare at her.  She was surrounded by gangsters who killed outsiders.  “Can’t I just come with you?  
What if someone asked about my… club?”  Allyson was careful with her words.  Scholar frowned. </p>
<p style="text-indent: 50px">
“Oh, right.”  Scholar said, scanning Allyson’s outfit.  She pointed to the silver pin that Allyson 
was wearing on her bolero jacket.  “You need to get rid of that.”  She held out her hand.  “I can 
take it.  The police will probably pat you down.  You will be arrested if they find you with that.”  
Allyson grimaced at the thought.  She was familiar with shady police brutalizing witnesses on orders 
from benefactors.  If <i>ROC</i> called the police here because Allyson pulled her gun on Haelin, 
Allyson was going to be in for a rough night. </p>
<p style="text-indent: 50px">
“Alright.”  Allyson said, quickly taking off the pin and handing it to Scholar.  “Hurry.”  She ran a 
hand through her hair as Scholar accepted the pin and nodded. </p>
<p style="text-indent: 50px">
“It won’t take long.”  Scholar said looking around.  “Don’t talk to anyone, and don’t leave this 
spot.  The only way you are getting out is with my help.  Understood?”  Scholar said.  Allyson took 
a deep calming breath and nodded.  She started to wonder if Cealen was right.  This was too dangerous 
for a pair of reporters.  Allyson had never dealt with this level of organized crime before.  
<i>DNA</i> and <i>ROC</i> were both university clubs that had an abundance of resources available to 
them.  If they killed her, Allyson feared they would target Cealen next. </p>
<p style="text-indent: 50px">
“Right.”  Allyson said when Scholar wouldn’t leave.  Allyson had already marked a few exits when she 
entered with Evangelina and <i>DPS</i>.  Once Scholar left to speak to the police, Allyson would make 
a run for it. </p>
<p style="text-indent: 50px">
“Right.”  Scholar repeated.  She was giddy with joy.  “We can’t wait to have you in <i>DNA</i>, 
Allyson.  We knew yesterday, after you gave us the slip, that you were a force to be reckoned with.  
We can put your skills to good use in Niveal.”  She said before rushing off.  Allyson shook her 
head.  Scholar was one of the people in the van!  They were following her since yesterday.  The nerd 
was probably preying on Allyson the minute she walked into the convention center.  There was no time 
to hesitate or be scared.  That only ended in death.  She had to get out of there and warn Cealen 
about these two gangs before it was too late. </p>
<p style="text-indent: 50px">
Allyson peeked around the stairs.  Scholar was distracting the police and <i>ROC</i>, so Allyson 
slipped away.  She headed for the opposite end of the lobby, sticking to more empty spaces.  She 
avoided running into people, especially from those two gangs.  Her heart was racing.  Allyson was 
sweating.  Her mind started whispering all kinds of nasty thoughts as she passed people that stared at 
her.  The voices echoing around the convention center could be about her.  People that were staring at her 
could be plotting her murder.  Allyson tried to block it out and focus, but her paranoia was 
winning. </p>
<p style="text-indent: 50px">  
Two sorority girls appeared in front of the exit she was planning to leave the convention center 
through.  Allyson froze in place, wondering where to go instead.  The convention center was starting 
to feel suffocating, like a game of chess where she had no option of winning.  <i>ROC</i> and <i>DNA</i>
were closing in around her.  She walked over to a door and pulled at the handle.  It didn't open.  
The room had signs for an event dated next week, after the Career Showcase.  Her heart slammed in 
her chest.  </p>
<p style="text-indent: 50px">
“Well, shit.”  Allyson groaned.  She glanced at the exit door.  The <i>ROC</i> girls were standing 
guard, checking everyone that passed through.  They were waiting for her.  She needed help.  “Now 
whaa-,”  The door Allyson was standing in front of opened suddenly, and a pair of hands grabbed her 
and pulled her into the dark room.  The door was shut just as quickly, and silence surrounded her.  
It took a few seconds for Allyson’s eyes to adjust.  Only one other person was in the room with her.  
She took a minute to register what just happened.  Allyson clutched the front of her dress, willing 
her heart to slow down. </p>
<p style="text-indent: 50px">
“Are you alright?”  A woman whispered.  She had curly brown hair and a leather jacket.  It was the 
same woman she had seen sitting at the <i>FNX</i> table.  She wasn’t looking at Allyson.  The woman 
was focused on listening to the commotion on the other side of the door.  After a few moments of 
silence, the woman sighed.  “It doesn't seem like they saw us, good.”  The woman pulled out her phone 
and started to rapidly text. </p>
<p style="text-indent: 50px">
Allyson glanced at the woman’s badge that was illuminated by the smartphone light.  The sigil was 
the same phoenix that Cealen described with the letters <i>FNX</i> on it.  This was a member of the 
most dangerous gang in all of Niveal.  <i>FNX</i> was the top-rated gang, and the woman’s professionalism 
made Allyson tense.  This wasn’t a stuck up sorority girl or a scheming academic.  This was a real 
deal crime boss.  Allyson could admit she was scared.  The woman’s name was Jasminy.  When Jasminy 
finally met Allyson’s gaze, heat rushed to Allyson’s face.  She had no idea what was happening, and 
was completely at the mercy of the Niveal gangs.  This was how reporters ended up dead, by walking 
into dangerous situations.  Allyson should have waited to attend any kind of event until she had a 
better handle on how things operated. </p>
<p style="text-indent: 50px">
“Relax.”  Jasminy laughed, offering her a smile.  After texting, Jasminy offered Allyson her hand.  
“My name is Jasminy, but you can call me Jas.”  She introduced politely.  Allyson blinked in 
confusion.  This was not what she expected from a crime boss.  No one else at the event introduced 
themselves.  Since everyone wore badges with their names, the thought seemed silly. </p>
<p style="text-indent: 50px">
“Oh,”  Allyson responded nervously.  “I… I’m Allyson.”  She placed her hand in Jasminy’s, and the 
two shook.  It was a brief respite of humanity in the swirling storm of chaos Allyson found 
herself in. </p>
<p style="text-indent: 50px">
“It’s nice to meet you.”  Jasminy whispered.  She held her hand to the back of the room.  
“Come.  Let us find somewhere to talk that isn’t surrounded by the <i>ROC</i> or <i>DNA</i>.”  
Jasminy said, gesturing to the back of the room.  There was a warehouse entrance that allowed 
forklifts to enter the room to set up for events.  From where they stood, Allyson could see the 
light from an open door.  Surprising, the room was empty of people.  Nobody was working to set up the 
room for the event.  Maybe the workers were on break, Allyson wondered.  She raised an eyebrow 
at Jasminy.  The timing was too suspicious.  In her field of work, nothing was a coincidence. </p>
<p style="text-indent: 50px">
“Thanks but…”  Allyson wasn’t sure what to say.  “I kind of pissed some people off.” </p>
<p style="text-indent: 50px">
“I saw.”  Jasminy laughed.  “It was very entertaining.” </p>
<p style="text-indent: 50px">
“What?”  Allyson asked.  She couldn't understand how the scene was entertaining.  She thought 
about what Scholar said, and how <i>DNA</i> could use her talents.  Jasminy was probably no 
different.  “No offense.”  Allyson said, slowly following behind Jasminy.  They moved past tables 
full of glass bottles filled with colorful liquid.  “I’m not in the market to join another… club.”  
Allyson said, wondering what the event was.  She picked up one of the bottles as they passed the 
last table. </p> 
<p style="text-indent: 50px">
“No offense.”  Jasminy answered with a laugh.  “But I wasn’t offering.”  She walked up to Allyson 
and pointed to the bottle in her hand.  “This is for a tournament that starts in a few days.  
The bottles are not made of real glass.  It’s sugar glass.”  Jasminy said.  She grabbed a green 
bottle and smashed it on the floor.  Allyson flinched, but the glass didn’t fracture into sharp 
pieces.  It made a clinking sound and shattered into tiny harmless pieces.  As the liquid splashed 
over the glass, the tiny shards disappeared.  The green liquid started to dry up, leaving a green 
stain on the floor.  Allyson was mesmerized. </p>
<p style="text-indent: 50px">
“Huh!”  Allyson let out with a smile.  “What event?”  Her brain flipped through all the events 
that were ever covered by The Empire.  She couldn't think of a single event of this nature.  This 
tournament sounded fun.  Fun was not want happened in Niveal.  Jasminy brushed her hands together 
and wiped them on her black jeans. </p>
<p style="text-indent: 50px">
“It’s mostly for people to relax and have fun.  The children love it too.”  Jasminy said, walking 
to the warehouse entrance.  “It’s an alchemy themed game where they get to smash all these bottles 
together.”  She gestured to the room.  Allyson couldn't resist smiling.  The thought of something 
like this being held in Niveal was front page worthy!  Was she running for her life, yes.  Was 
she still an ace reporter, also yes.  Allyson glanced around the room, taking it all in.  
Cealen would need as much detail as she could get in order to write his amazing, eye-catching 
headlines.  Allyson ran her thumb over the glass bottle in her hand as excitement made her heart 
race again.  This was just the tip of the iceberg.  She could tell there were more secrets this 
town was hiding, and she and Cealen wouldn’t stop until it was all exposed. </p>
<p style="text-indent: 50px">
“Allyson!”  Jasminy hissed.  They were running out of time.  She knew Scholar was already on the 
prowl for the newbie that blew into town.  Her team had already alerted her of them and their plans.  
More police had shown up, and Rabbit was heading the search for Allyson from the <i>ROC</i> end.  
They had to get out before Allyson was thrown in a <i>DNA</i> van and never seen or heard from again.  
Niveal already had a bad reputation.  It didn’t need for this brave young lady to die, Jasminy thought.  “We need to 
go!”  She emphasized as quietly as she could. </p>
<p style="text-indent: 50px">
Allyson was pulled from her thoughts and set the bottle back down.  “Right.”  Allyson muttered.  
Just as she set the bottle down, the door knob giggled and the door shook.  Someone was trying 
to enter the room.  Allyson and Jasminy exchanged a nervous glance. </p>
<p style="text-indent: 50px">
“I’ll get the staff to open this room.  It’s possible she got in somehow.  It’s better to be 
safe than to allow an armed assailant to sneak around the mixer.”  Said a male voice from the 
other side.  Allyson tensed. </p>
<p style="text-indent: 50px">
“The boys are checking around back.”  Rabbit's voice echoed in the silent room.  “If you find 
her, she’s ours.”  A shiver of fear ran down Allyson’s spine. </p>
<p style="text-indent: 50px">
“Quickly!”  Jasminy walked over and grabbed Allyson’s hand.  “Allyson!”  She didn't wait for Allyson 
to respond.  Jasminy had to save this fool before she was killed.  She pulled out her phone 
again, as she dragged Allyson through the warehouse door. </p>
<p style="text-indent: 50px">
<i>We need to go, now!</i>  Jasminy typed quickly into the group chat.  <i>Is everyone in 
position?</i>  Immediately, her <i>FNX</i> team started to respond.  After Allyson drew her 
gun on Haelin in the negotiation room, Jasminy and her team prepared an exit strategy.  
Jasminy hadn’t offered Allyson a position in her <i>FNX</i> mafia family, but she was considering 
it.  She needed to feel out the newbie first, see if Allyson had what it would take to be a proud 
member of <i>FNX</i>.  Living and operating in Niveal was not for the weak, and Allyson only just 
arrived.  Nevertheless, Jasminy was good at reading character.  Her eyes skimmed over the texts 
that were pouring in about getting Allyson safely out of the mixer.</p>
<p style="text-indent: 50px">
“Look out!”  Allyson pulled Jasminy back as someone took a swing.  On impulse, Allyson drew her 
gun and pointed it at the men sneaking around the warehouse.  They were stopped next to crates 
stacked high with glass bottles full of colorful liquid. </p>
<p style="text-indent: 50px">
“Well, well, well.”  One of them said with a goofy smirk.  “Look who tried to steal away our 
punching bag.”  The man said to the other.  “<i>FNX</i>.”  His name badge read Dexter.  He had 
shaggy brown hair that ended at his shoulders, and was wearing a pink sweater that matched the 
<i>ROC</i> sorority.  Instead of the sorority logo for Rho Omega Cappa, it had a vertical logo 
with different stylized lettering.  It was an <i>ROC</i> fraternity, partner to the sorority, 
Allyson realized.  She glanced from one man to the other.  She needed to buy time so she could 
come up with a plan. </p>
<p style="text-indent: 50px">
“Didn’t realize sororities let boys in.”  Allyson teased, surveying her surroundings.  They 
were in a narrow space, not ideal for a fist fight.  Crates of bottles were everywhere, and 
the loading dock roll up door was closed.  Rabbit was closing in behind them from the room. The 
light from outside was entering through a side door in the warehouse that was cracked open.  
These fraternity boys were blocking their way.  Jasminy stuffed her phone in her pocket and 
glanced at Allyson, who was standing in front of her.  This was the second time today that 
Allyson surprised her.  The situation was under <i>FNX</i> control, for they owned and 
operated the convention center under an alias, but this was the perfect opportunity for Jasminy 
to evaluate Allyson.  </p>
<p style="text-indent: 50px">
“Hand her over, Jasminy.” The other man said.  His name tag read Darryl.  “Our leader has 
blacked listed her and her stupid club mates.”  Allyson gripped her pistol tighter.  It was 
her fault that <i>ROC</i> went after <i>DPS</i>.  Evangelina and the other two were probably 
dead now, or were going to be killed.  Allyson would have to carry that around on her conscious. </p>
<p style="text-indent: 50px">
Jasminy didn't say a word.  The police weren’t going to be able to convince the staff to open 
the room, so they had time.  Her team made sure her bike was waiting in the alley, ready to 
go, with two helmets.  Newcomers were always easy targets for the gangs of Niveal, and nobody 
knew that better than Jasminy.  She had been around for a long enough, and had seen it all.  
Rabbit didn't scare her, and neither did the Professor.  Neither of them could stand toe to toe 
with her in terms of being a strong leader. </p>
<p style="text-indent: 50px">
“Leave the members of <i>DPS</i> alone.  I’m not part of that club anymore.”  Allyson stated. </p>
<p style="text-indent: 50px">
“Or what?”  Dexter laughed, rubbing his hand through his hair like a prima donna.  “You’ll shoot 
us?”  He taunted.  Dexter smirked at Allyson.  “I bet you don’t have it in you.  You’re a 
coward!”  He laughed, nodding at Darryl.  They both took a step forward. </p>
<p style="text-indent: 50px">
Allyson fired, and Dexter’s right shoulder exploded.  “I’m not the one wearing a girl’s sweater 
and taking orders from some demented grandma!”  Allyson shouted.  The shot rang out in the 
warehouse, echoing off the walls.  Jasminy stifled a laugh.  Dexter stumbled backwards, knocking 
over crates of the glass bottles, before falling to the floor.  Everywhere the colorful liquid 
splashed on Dexter, it stained his pink <i>ROC</i> sweater.  He cried and moaned for Darryl to help him. </p>
<p style="text-indent: 50px">
“You bitch!”  Darryl grabbed Allyson’s wrist and punched her across the face.  The two wrestled 
for control over the gun.  “You’ll pay for hurting my friend!” </p>
<p style="text-indent: 50px">
“Great!”  Allyson answered.  “Send me the bill!”  She rammed the palm of her hand into Darryl’s nose, 
breaking it on impact.  Darryl didn’t release her.  Jasminy pulled out her phone.  This was going to 
require some clean up before the convention center staff found out what happened.  She was hoping 
for a quick get away, but things were escalating. </p>
<p style="text-indent: 50px">
“JAS!”  Dexter cried in pain.  He managed to sit up, grabbing his shoulder.  “Aren’t you going to do 
anything?  We have an agreement!”  Dexter glared at Jasminy.  Even through the pain, Dexter managed 
a smirk.  Niveal had reached a measure of peace when Rabbit, Professor, and Jasminy reached a 
mutual agreement of preventing further bloodshed between their clubs.  They were the strongest, with 
the most resources, and the most influence.  In order to prevent Niveal from falling into anarchy, the 
leaders came together in hopes for peace.  For <i>ROC</i> and <i>DNA</i>, it was easy.  Jasminy 
rolled her eyes at Dexter and shook her head.  The two clubs were literally in bed with each 
other, and agreed to whatever measures the other suggested.  In the talks for peace, Jasminy was 
outnumbered. </p>
<p style="text-indent: 50px">
“I don’t know what you’re talking about?”  Jasminy said, stepping over Dexter.  “This is not my fight.  
I am just leaving.”  She didn't miss the opportunity to ‘accidentally’ kick Dexter in his bloody 
shoulder.  “Oops!  Sorry.”  Jasminy smiled.  “It was a mistake.” </p>
<p style="text-indent: 50px">
“Jas!  You have to help us!”  Dexter moaned.  “Do something about her!”  Jasminy glanced over her 
shoulder.  Darryl and Allyson were still fighting, but Allyson was winning.  She pinned Darryl 
against the crates and shot him in the back of the thigh.  He slumped to the floor, screaming in pain. </p>
<p style="text-indent: 50px">
“No, I don’t have to do anything.”  Jasminy said, folding her arms.  “The agreement was to avoid 
fights between our clubs.  Allyson is not part of <i>FNX</i>.”  Jasminy said.  This time, she 
sported a grin as Allyson limped over to her.  “There were no such rules for helping each other, 
but I’ll be sure to bring this up with Rabbit later.”  She laughed.  “If her club members are so 
weak, begging for help, I want to know how she would have me respond.”  The jab hit hard.  Both 
Dexter and Darryl glared at her. </p>
<p style="text-indent: 50px">
Allyson missed the exchanged as her vision started to blur.  She took some hard hits from Darryl 
and was feeling nauseous.  She stowed her gun away and took a deep breath as she stumbled into the 
afternoon sun.  It was a relief to get out of the convention center, but she was in bad shape.  
Outside, she leaned against the wall, holding her ribs.  All she could think about was Cealen 
being in danger.  There was no doubt in her mind that they would trace her back to the motel.  
<i>DNA</i> had spotted her yesterday and followed her from the motel.  She had to warn Cealen before 
it was too late. </p>
<p style="text-indent: 50px">
Allyson grabbed her phone and texted their special shorthand to Cealen.  She wasn’t sure how much 
longer she had until she passed out.  After checking the text to make sure Cealen would understand, 
she sent it.  Jasminy came out of the door next, causing Allyson to flinch.  Her phone dropped onto 
the ground. </p>
<p style="text-indent: 50px">
“You look like shit.”  Jasminy sighed.  She was impressed by the newcomer, but Allyson was in danger.  
“Come on, then.”  She said, pulling Allyson off the wall.  With ease, Jasminy slipped one of Allyson’s 
arms over her shoulder.  After her exchange with Dexter, <i>FNX</i> was not a good hiding spot for 
the brave newbie.  Allyson needed at least twenty-four hours of waiting before she could join a new 
club.  She had to lie low.  Hopefully by then, Rabbit and Professor would have given up on her. </p>
<p style="text-indent: 50px">
“Wait.”  Allyson groaned.  She looked down at her phone.  Jasminy followed her gaze.  It wouldn’t 
be good for it to fall into the wrong hands.  Jasminy reached for Allyson’s gun and drew it.  
With two quick pops, the phone was utterly destroyed.  “Hey!”  Allyson groaned.  She grabbed her side.  
Only then, did Jasminy see the blood staining Allyson’s dress. </p>
<p style="text-indent: 50px">
“We don’t have time.”  Jasminy stated.  There was only one place Allyson could hide with these injuries.  
There was only one person she could trust to treat Allyson without informing the authorities.  Jasminy 
rolled her eyes and stowed Allyson’s gun back into the holster.  “You are coming with me.” </p>
<p style="text-indent: 50px">
“Wh-where?”  Allyson asked.  She wasn’t going to make it.  Waiting nearby were two people holding 
helmets.  Allyson closed her eyes as she heard them talking in a language she didn't understand.  Her 
world was fading to black.  Jasminy chuckled and mounted the motorcycle.  The other members of <i>FNX</i>
 helped Allyson sit in front of Jasminy.  They fixed the helmet on for her, since Allyson was too weak 
 to do it herself. </p>
 <p style="text-indent: 50px">
“Where are we headed, you ask?”  Jasminy said, revving the engine.  The other members backed away, 
fleeing from the scene so as not to be caught up in the drama.  “To Silver Rose Shield.”  Jasminy 
stated, driving as fast as she could.  She sped away from the convention center and through side 
streets.  “Their leader is an emergency room nurse for Niveal Hospital.  They will be able to help 
you.”  She sighed as Allyson went limp in her arms.  “They better.” </p><br>

<p style="text-indent: 50px">
Back at the motel, Cealen was scrambling to clean up everything and pack up.  The van Allyson had 
described, with the license plate GEN3T1X, was in the parking lot.  Mysterious people exited the 
van and entered the lobby.  They were all in matching prep academy uniforms that looked straight from 
shows Cealen watched.  This was the infamous gang <i>DNA</i>.  He had no doubt they were here looking 
for Allyson.</p>
<p style="text-indent: 50px">
“My god…”  Cealen mumbled as he started to sweat.  After he packed all their technology 
up in one suitcase, he hid his and Allyson’s real identities and press passes in his personal bag.  Since 
Allyson was headed into the lions' den, she left her press pass with Cealen.  Their clothes and other 
essentials for travel were packed in the second travel size suitcase.  In minutes, Cealen had cleared the room. </p>
<p style="text-indent: 50px">
His burner phone buzzed on the night stand.  Cealen glanced over at it as he zipped up the last of their 
things.  It was a text message from Allyson.  Cealen took a breath.  He had to stay calm.  From his 
research into the university, he learned it was <i>ROC</i> that controlled the police, not <i>DNA</i>.  
Panicking wouldn’t serve him at this moment.  He held out his hands as a metaphorical symbol to remind 
himself to stay calm.  He stood there, taking another deep breath, and trying to focus on what to do next.  
They had been in situations like this before.  It was just part of the territory of being good investigative 
reporters.  “She is probably on her way back now.”  Cealen told himself.  “Ally is fine.  Stay positive.”</p>
<p style="text-indent: 50px">
Cealen grabbed his phone and checked the message.  His heart nearly stop.  Allyson was hurt and in danger.  
The short message was to alert him to leave the motel.  In case of an emergency, they had selected a gas 
station just outside of town where they would meet.  From her message, Allyson indicated she was going to 
head there.  Cealen didn't believe her.  The <i>DNA</i> van was already here, looking for her.  He had 
to find her first.  “Ally, aye no!”  Cealen groaned.  This was bad! </p>
<p style="text-indent: 50px">
A loud, rapid knock sounded on the door.  Cealen flinched, fumbling with his phone so he didn't 
drop it.  He held his breath, clutching his phone to his chest.  If it was <i>DNA</i>, he prayed they 
would believe no one was inside.  The lights were off, and he didn't move a muscle. </p>
<p style="text-indent: 50px">
“Cealen!”  A young man shouted before knocking again.  “Cealen are you there?”  Cealen breathed a 
little easier.  It was the nice young man from yesterday.  He took a steadying breath before he unlocked 
and opened the door. </p>
<p style="text-indent: 50px">
“Antares, it’s good to-,” Cealen started before Antares forced him inside.  Behind Antares, three 
women followed.  Antares grabbed Cealen by the shoulders and moved him away from the door to allow 
the ladies inside.  Cealen tensed.  He was used to working jobs with Allyson, but never had danger 
come so close.  This wasn’t the same young man that causally greeted him in the grocery store yesterday.  
It was a gang leader, and the look on Antares’s face was serious.  He was here for business.  Cealen 
prayed it wasn’t because of Allyson.  She had a propensity for getting into trouble, but this would 
be a stretch.  Pissing off the gangs of Niveal would only complicate their chances of finding Dolores. </p>
<p style="text-indent: 50px">
“I’m sorry for doing this, Cealen, but you have to come with us.”  Antares said, nodding to his 
team.  “Quickly, grab his stuff.” </p>
<p style="text-indent: 50px">
“What?”  Cealen asked.  His skin drained of color.  “Antares?” </p>
<p style="text-indent: 50px">
“It’s not safe here.”  Antares tried to explain.  They didn't have time. </p>
<p style="text-indent: 50px">
“What a drag.”  One of the women said.  She had shadows under eyes that alluded to poor sleeping habits.  
Her feet dragged across the carpet as she entered the room and looked around.  “And here I was just going 
to sleep the day away.  Now, I have to help hide some idiot.”  Cealen wasn’t sure how to respond to 
that.  The woman picked up one of Cealen’s bag and slowly placed it on her shoulder.  “You should have 
just come to the clubhouse.  We wouldn’t be in this mess if you had.” </p>
<p style="text-indent: 50px">
“Sleepy!”  One of the other women said.  She looked as young as Antares and had her brown hair in a 
ponytail.  She glanced around the room with bright eyes.  “That’s no way to treat our new member!”  The 
young woman clasped her hands in front of her.  “Look how neat you keep house!  This is going to be great!  
We need someone like you back at the <i>EYE</i> House.”  Cealen glanced from the young woman, to Antares.  
He did not have time to deal with <i>EYE</i>.  He had to find Allyson. </p>
<p style="text-indent: 50px">
“What is going on?”  Cealen asked.  He wiggled out of Antares’s grip.  “I’m afraid I can’t stay.  I 
need to find my partner.”  When the young woman grabbed his personal bag that held their press passes, Cealen 
gasped.  Allyson would be in even more danger if they learned she was working for The Empire.  He grabbed it 
from the young woman.  “Excuse me, but I must ask you all to leave.”  This was becoming overwhelming.  
Sleepy carried the bag with their clothes in it out the door.  Antares was standing near the doorway, 
nervously staring at the lobby, while the other two women grabbed the remaining luggage in the room. They 
were all ignoring Cealen and his pleas for them to stop.</p>
<p style="text-indent: 50px">
“Ugh.  This is so heavy!”  The last woman complained.  Her coppery skin glistened with sweat.  She glared 
at Cealen as she dragged the suitcase with their equipment in it to the door.  “You owe me a massage later 
for all this manual labor!” </p>
<p style="text-indent: 50px">
“Sorry, Cealen.”  Antares sighed.  He ran his hand through his red hair.  “These are some of my club mates, 
Sleepy, Fair, and Laltil.”  He introduced the woman in turn, gesturing to the tired one, the young one with 
brown hair, and the woman with copper skin.  Sleepy nodded before walking out the door.  The other two 
followed behind.  Antares glanced over the room.  “Is that all your stuff?  Your partner’s too?”  It seemed 
odd that two people would bring so little.  It was enough to raise a red flag, but Antares would worry about 
that later.  Right now, <i>FNX</i> warned him about <i>DNA</i> coming after his new member.  He had hoped 
Cealen would be safe with his club’s pin, but that was never the case when dealing with <i>DNA</i>.  Antares 
had to get Cealen out of the motel and to safety. </p>
<p style="text-indent: 50px">
“Yes.”  Cealen answered nervously.  He hoisted his personal bag on his shoulder.  “Listen, Antares, I have to 
find my partner.”  Cealen told the young man.  “I fear she is in danger.”  Antares let out his breath all at 
once.  He held Cealen’s gaze for a few heart beats, wondering if it was even a good idea to get his gang 
involved in this.  Dealing with the top three gangs of Niveal was risky business.  Antares rarely took those 
risks.  He preferred to stay neutral to protect the calm and somewhat peaceful environment he established 
for his members. </p>
<p style="text-indent: 50px">
“Your partner is in danger, but there is nothing you can do to help her now.”  Antares explained.  He allowed 
Cealen to leave before he swept the room for any lingering evidence that people were there.  As Fair had 
commented, the room was surprisingly clean.  There was no dust, no wrinkle in the blankets, and no used 
coffee pods from the mini bar on the counter.  The pair were here for two days and one night, yet the room 
looked unused now.  There wasn’t even trash in the waste bin.  Antares sighed and turned to Cealen.  He wasn’t 
dealing with just any newcomers.  These were a professional pair. </p>
<p style="text-indent: 50px">
“I’ll explain on the way.”  Antares muttered as he watched his team descend the stairs and turn the corner.  
Their car was waiting to take the luggage back to their gang headquarters, the <i>EYE</i> house.  Once his 
team loaded the bags, they would speed away.  Antares didn’t want any of them getting involved with 
confronting <i>DNA</i>.  “Take a walk with me, Cealen.”  Antares said, shutting the motel room door. </p>
<p style="text-indent: 50px">
“What?”  Cealen was starting to sweat.  He trusted Antares wasn't here to hurt him, but he didn't feel as 
confident about Allyson.  Antares was the leader of a rival gang, one that Allyson wasn’t a part of.  Cealen 
never had to navigate these situations before.  He glanced over his shoulder at the empty motel room as 
he walked with Antares to the stairs.  This was risky.  He knew that, but Cealen didn’t know what else 
to do.  He and Allyson didn’t know about Niveal like the gangs did.  Allyson always stressed leaning on 
those who knew better.  In this situation, with gangs breathing down their necks, Cealen had no choice.  
He had no choice but to lean on Antares. </p>
<p style="text-indent: 50px">
“HEY!”  A woman shouted behind them.  They had made it down the stairs, but they weren’t fast enough.  
Antares sighed as he turned to greet the troublemaker. </p>
<p style="text-indent: 50px">
“What is it, DragonGirl?  We had an agreement that <i>DNA</i> wouldn’t show up here looking for new 
members.”  Antares stated, folding his arms.  He stepped in front of Cealen, creating a barrier between 
his new member and the threat.  “This is our turf.”  The young woman wasn't much older than him, and she 
had fake bleach blonde hair.  Her large hoop earrings and thick, obvious lip liner made Antares cringe.  
Her attitude was just as bad as her makeup. </p>
<p style="text-indent: 50px">
“We aren’t here to recruit, Antares.”  Another woman said.  She walked up to them with four other <i>DNA</i>
 members behind them.  The situation was getting dangerous.  Antares had to deescalate the situation 
before it got them both killed.  This woman was older and stood taller than Cealen.  She had gray and 
white hair push up in a giant clump on her head.  It reminded him of a beehive.  The woman glared at 
Cealen.  “We are here for a troublemaker.”  The old woman said.  “Her name is Allyson.  She was saying 
in the room you just came out of.”  She said in a sickeningly sweet voice. </p>
<p style="text-indent: 50px">
“Listen, Gen.”  Antares started.  The old woman huffed immediately. </p>
<p style="text-indent: 50px">
“The name is Queen Genevieve.”  QueenGen snorted.  She held her hand to Cealen, making him stand 
taller.  “And we aren’t here to recruit anyone.  We are here to take care of a problem.”  Her old 
lips worked their way into a smile, nearly cracking her face in two with all the wrinkles.  “He 
must be working with Allyson, so we need him to come with us.” </p>
<p style="text-indent: 50px">
“Yeah!”  DragonGirl shifted her weight to one leg and threw her hands on her hips.  Her uniform 
was messy and unkempt.  She was a true nasty gangster in Cealen’s mind.  “He’s probably part of 
the same shitty little club that Allyson is part of, so how does that even involve you?  What are 
you doing here, Antares?”  She narrowed her eyes on Antares, who quietly stood his ground.  “Sucking 
off <i>FNX</i>’s tit again?”</p>
<p style="text-indent: 50px">
Antares’s hands clenched into fists.  This wasn't the first time, 
and he knew it wasn’t the last time, that his gang was accused of supporting <i>FNX</i>.  It 
wasn’t like that.  Antares worked hard to stay neutral, doing his best to protect his people 
and live in peace.  <i>FNX</i> warned him that his member could be in danger, and that’s why 
he was here.  He didn’t even know Allyson! </p>
<p style="text-indent: 50px">
Cealen didn't understand what was happening.  He stared from the clown makeup woman, to the old 
fossil, to Antares.  “I’m sorry if I have caused you trouble, Antares.”  Cealen’s stomach flipped 
as he slowly grabbed the collar of his jacket where the <i>EYE</i> pin was fixed.  These were gangs, 
and he had to address his audience properly.  Cealen was a master with words, and now his very life 
depended on it.  The women’s gaze followed his hand.  When they saw the pin on his jacket, their 
smug smiles melted away.  “I promise to make up for this.”  Cealen said bravely.  It took all his 
strength to stand straight, but he managed. </p>
<p style="text-indent: 50px">
“Oh.”  DragonGirl sneered.  She glanced at QueenGen.  “This loser is part of <i>EYE</i>.”</p>
<p style="text-indent: 50px">
“Allyson isn’t suddenly part of <i>EYE</i>, is she?”  QueenGen snapped.  She was thirsty for 
blood and wasn’t satisfied with what happened so far.  Not only had all the information from the 
motel computer been erased, but the security footage around the building had been scrambled.  QueenGen 
tapped her Botox filled lips as she thought about what to do.  The employee who was working in the 
lobby informed them that <i>FNX</i> had stopped by last night.  She had no doubt it was probably 
one of their members that trashed the security.  <i>DNA</i> had nothing. </p>
<p style="text-indent: 50px">
“I’ve never even met an Allyson.”  Antares stated confidently.  It was true, but he had to be 
careful.  <i>DNA</i> was known to be aggressive and attack, even if they were wrong to do so.  
Antares only ever met Cealen, and their exchange was pleasant.  “I’m here for Cealen.  He accepted 
the pin yesterday, and we made room for him at the clubhouse already.”  Antares eased his stance and 
slipped his hands into his pockets to try and convey a nonconfrontational posture.  They didn't need 
to know he slipped his fingers into his brass knuckles just in case.  “There is no Allyson in 
<i>EYE</i>, just so you know.”  It was quiet for a few heart beats as they faced off. </p>
<p style="text-indent: 50px">
“How can we be sure?  Maybe we should head to <i>EYE</i>?”  DragonGirl laughed.  She took a step 
forward, and Cealen took a step back.  Antares stepped in front of her to protect Cealen.  DragonGirl 
shrieked with laughter.  “What a chump!”  She cackled.  “He is definitely not who we are looking 
for.”  She titled her head as she glanced over Cealen, head to toe.  “I bet he doesn't even have 
a weapon on him.  Ha!  What a loser.”  Antares narrowed his eyes at DragonGirl.  Her self entitled 
attitude was something he despised. </p>
<p style="text-indent: 50px">
“Enough!”  Antares said.  He took a breath and addressed QueenGen.  She was the more senior gang 
member, and that wasn’t just because of her age.  In the gang landscape of Niveal, there was a 
hierarchy that was followed and respected.  In <i>DNA</i>’s case, QueenGen was part of the elite 
class.  She wasn’t part of leadership, but her words carried weight.  “If we’re through here, I 
want to introduce Cealen to the rest of <i>EYE</i>.”  Antares said.  Without turning his back, 
he encouraged Cealen to walk away.  “Go on, Cealen.  I’ll meet you at the grocery store around 
the corner.”  Antares instructed.  It was a safe place that they both knew about.  As part of 
the agreement for peace among the smaller gangs, the top three were not allowed inside the grocery 
store.  Cealen would be safe there, and Antares prayed he could make it before violence broke out. </p>
<p style="text-indent: 50px">
The other members of <i>DNA</i> chuckled.  Some had returned to the van, starting the engine.  
Two men stayed with them.  They were eyeing Cealen as he backed away from Antares and the women.  
This was his chance to get away.  Cealen would try and get to the grocery store, but it was 
obvious these gangs were about to fight.  His heart picked up a beat.  Antares was younger than 
he was.  He couldn’t just abandon the young man.  Unlike what DragonGirl assessed, Cealen did have 
a weapon on him.  Just because he was nervous about fighting back, didn’t mean he couldn’t. </p>
<p style="text-indent: 50px">
“S-Should we be going, Antares?”  Cealen asked.  He didn't move from his spot. </p>
<p style="text-indent: 50px">
“What do you think, Ihrel?”  One of the men asked in a sigh.  He pushed back the shaggy black hair 
from in front of his face and shifted his feet to a fighting stance.  “Do you want the new guy or 
Antares?”  Antares tensed.  They weren’t going to let him go this time.  Ihrel and Kither were some 
of the attack dogs <i>DNA</i> had in their arsenal.  The blood that ran in the streets from <i>DNA</i>
hits were usually from Ihrel and Kither. </p>
<p style="text-indent: 50px">
“I don’t know, Kither.”  Ihrel said, cracking his knuckles.  He looked more built than Kither did, 
and Cealen flinched from the cracking.  “Will you be pissed if I say Antares?”  He flashed a smile 
that made Cealen grit his teeth.  Where Kither looked more like a lean assassin in his university 
uniform, Ihrel looked like a tall, buff jock with an attitude to match. </p>
<p style="text-indent: 50px">
“It doesn’t matter to me.”  Kither tisked.  His lidded eyes shifted from Antares to Cealen.  “We 
were sent here for a job.  Let’s get it over with so I can get back to my studies.”  His voice was 
low and sent a chill down Cealen’s spine.  Kither was the type of gangster Cealen was afraid of.  
They didn’t have any remorse for the bad stuff they did, and they never backed down from a fight.  
The women didn’t strike fear into his soul like Kither did. </p>
<p style="text-indent: 50px">
“What was your job?”  Antares asked.  He shifted into a fighting stance.  When he took a step 
back, DragonGirl grabbed him by the collar of his shirt.  That was all it took for Antares to 
make his decision.  It was risky to fight <i>DNA</i>, but his pride as a leader was on the line.  
He withdrew his hands from his pockets with the brass knuckles and punched DragonGirl hard 
in the jaw.  He hated fighting against her, but he had no choice.  He and Cealen were both 
going to die if they didn’t fight back. </p>
<p style="text-indent: 50px">
DragonGirl screeched in pain as blood sprayed from her mouth.  She released Antares and 
stumbled into QueenGen.  “KILL HIM!”  DragonGirl hollered to her accomplices.  She held 
her hand to her mouth, gasping for air. </p>
<p style="text-indent: 50px">
“RUN!”  Antares shouted, shoving Cealen out of the way toward the street corner before Kither’s 
punch could land.  The punch hit the wall of the motel, creating a loud thump!  Kither moved 
fast to attack Cealen. </p>
<p style="text-indent: 50px">
“You aren’t going anywhere!”  Ihrel laughed as he engaged Antares.  The two traded punches 
like they were fighting a professional match.  It wasn’t Antares first fight, but he didn't 
want to hurt Ihrel.  He wanted to grab Cealen and run as fast as they could. </p>
<p style="text-indent: 50px">
Cealen fell into full-blown panic attack mode.  The fear was replaced with narrow-minded 
focus.  He had to save Antares.  He dodged Kither’s combination and reached into his bag, 
grabbing his special pen.  “You’re faster than you appear, newbie.”  Kither stated, watching 
Cealen pull out the pen.  He backed up, putting distance between them.  Kither was a 
professional and had been in the game for a long time.  He didn’t trust anyone and 
wasn’t about to die over fresh meat that showed up in town.  Cealen took a deep breath 
and uncapped the pen.  Instead of a normal ball point pen top, it was a needle.  Kither tensed. </p>
<p style="text-indent: 50px">
“IHREL!”  Kither shouted to his partner, but there was no time.  Cealen moved fast.  He rushed 
Kither, matching the fighter's every move with a defensive one.  This was Cealen’s one 
shot.  They had underestimated him, which gave him the element of surprise.  After closing 
the distance between him and Kither, Cealen clicked the pen before stabbing it in Kither’s shoulder.  
The specialty knock out serum quickly raced through Kither’s veins.  “AHHH!  Son of a bitch!”  
Kither groaned before dropping to his knees.  “What the hell…?” </p>
<p style="text-indent: 50px">
“Kither!”  QueenGen hissed.  She gritted her teeth.  This was not the easy snatch and grab they 
had anticipated.  Ihrel was holding his own against Antares.  The peace loving leader of <i>EYE</i>
never enjoyed conflict and tried to stay out of it.  She was surprised to even see him here.  
The newbie fighting back was something they hadn’t anticipated.  QueenGen reached behind her 
and grabbed the gun she had stuffed in her waist band.  Like hell, was she letting some punk 
newcomer take out <i>DNA</i>’s best weapons, Ihrel and Kither!  She had no idea what Cealen 
did to Kither, but she was going to stop him. </p>
<p style="text-indent: 50px">
“Shit!”  Cealen hissed through grit teeth.  The special sedative would finish Kither off, so 
Cealen focused on Ihrel.  He clicked the pen, reloading another shot of sedative and sterilizing 
the needle with UV light.  The special pen was one that Cealen was gifted after he helped expose 
a pharmacist who was forcing his workers to deal in the drug ring.  The students working at 
the drug store wanted to help society, not participate in its problems.  After Cealen’s story 
broke, the students wanted to help.  They came up with all kinds of specialty drugs and remedies 
that Cealen and Allyson could use to help expose more truths.  One of those drugs was the 
special sedative inside Cealen’s pen.  The pen could hold ten shots, and had a focused UV light 
around the tip to sterilize the needle. </p>
<p style="text-indent: 50px">
“What the-?”  Ihrel pushed Antares up against the wall of the motel, holding him by the collar.  
They were both bleeding and bruised.  Neither one was ready to call it quits, and it was enough 
of a distraction for Cealen.  Quickly, Cealen stabbed Ihrel in the arm and forced himself between 
Antares and Ihrel. </p>
<p style="text-indent: 50px">
QueenGen fired two shots at Cealen, before she could stop herself.  One shot hit the motel wall, 
the other grazed Ihrel.  “Damn it!!  You worm!”  She shouted. </p>
<p style="text-indent: 50px">
“Are you stupid?”  DragonGirl slapped the gun from QueenGen’s hand.  “Don’t shoot Ihrel!”  The 
sounds of the shots drew other guests from their rooms.  They were causing a scene. </p>
<p style="text-indent: 50px">
“GO!”  Cealen reached behind Antares and pushed him toward the street corner.  His hyper focused 
state of panic had him spinning all kinds of narratives in his head.  With so many eyes on them, 
he had to take control over the story before <i>DNA</i> could.  “Leave us alone!  We don’t want 
to join <i>DNA</i>!”  Cealen hollered as he helped Antares to the corner.  The young man was 
dragging his right foot, Cealen noted.  “Is that how <i>DNA</i> operates?  <i>DNA</i> strong 
arms people into joining and doing their bidding?”  He continued to shout.  More shots were fired 
after them.  The pavement chipped, and the wall of the motel cracked from the gun fire.  
Cealen tensed as he felt a few bullets whizz by his head.  It wasn’t just <i>DNA</i> firing on 
them, it was the other guests as well. </p>
<p style="text-indent: 50px">
The whole motel erupted into chaos.  Guests were screaming at <i>DNA</i> and firing at the van.  
The sounds of bullets ricochetting off the metal rose in the parking lot.  Cealen didn’t dare 
look behind him.  He had to get Antares away from the madness.  This was more of what he expected 
from Niveal.  When they were safe around the corner and headed to the grocery store, Cealen capped 
his pen and stowed it in his bag.  Antares sighed a heavy sigh. </p>
<p style="text-indent: 50px">
“You…”  Antares groaned, glaring at Cealen.  “You and your partner…”  He was losing strength.  
Antares suspected the pair were up to something, but he never would have guessed they would be 
brave enough to start a war with <i>DNA</i>.  That’s what would happen after the shoot out at 
the motel.  If any <i>DNA</i> members were killed from the altercation, Antares knew there 
would be vengeance.  He prayed his club wouldn’t be the target.  “What are you doing here?” </p>
<p style="text-indent: 50px">
“Working.”  Cealen answered nervously.  It was the truth, but that’s all he would tell the young 
man who risked his life to save Cealen.  “I’m so sorry about this.”  He anxiously reached for 
the <i>EYE</i> pin.  “Here, you should take this back.” </p>
<p style="text-indent: 50px">
“No!”  Antares stopped Cealen from taking off the pin.  He groaned as his bloody fingers closed 
around Cealen’s.  “No… Sorry, but they will check the roster for your name.  It would be even more 
of a headache for me if you left now.”  Antares offered through a sigh.  “Just stay with us for a
 while.  We will figure something out once we get back to the <i>EYE</i> house.” </p>
<p style="text-indent: 50px">
“Alright.”  Cealen said as they reached the grocery store.  “I will keep the pin, but I can’t 
go with you.  I need to find my partner.”  Cealen said, taking a deep breath.  He helped Antares 
inside the store.  The bell chimed overhead.  “You should go back.” </p>
<p style="text-indent: 50px">
“Wait!”  Antares started to sweat.  <i>DNA</i> had eyes and ears everywhere.  They would kill 
Cealen for sure if the newcomer left his side.  “You can’t!  Just wait a minute!”  He held 
his hand out to brace himself on the shelves as they walked to the back of the store. </p>
<p style="text-indent: 50px">
“I can’t wait.”  Cealen said.  “Ally needs me.”  He prayed that was still true.  With the 
trouble they were both in now, Cealen wasn’t sure if Allyson was still alive or not.  Terror made 
him shiver as he thought about <i>DNA</i> capturing and torturing his partner.  His mind 
recalled all the headlines of reporters being decapitated and worse.  Cealen’s stomached 
turned.  He couldn't think about that now.  Finding Allyson was his top priority, no matter 
what condition she was in. </p>
<p style="text-indent: 50px">
The bell chimed from the front and the two men froze.  Cealen glanced over his shoulder.  
“WHERE THE HELL DID YOU GO!?”  Roared DragonGirl.  She lifted her gun in the air and let out two 
shots.  Cealen and Antares both flinched.  “Come out, now!”  DragonGirl ordered.  Her voice 
cracked as rage consumed her.  She had blood all over her arms and shirt. </p>
<p style="text-indent: 50px">
“Shit…”  Antares muttered under his breath.  He knew when he received a call from <i>FNX</i>, 
things were going to be tough.  This always happened.  He should have known better.  Antares 
avoided the mixer today because there was always trouble when <i>FNX</i> was around <i>DNA</i>
or <i>ROC</i>.  The three never did well together. </p>
<p style="text-indent: 50px">
“I’m sorry, friend.”  Cealen whispered, helping Antares to a back door that was labeled staff.  
DragonGirl continued to scream as she knocked over shelves and fired her weapon randomly.  From 
her ranting, Cealen presumed QueenGen was killed in the parking lot, and the <i>DNA</i> van was disabled.  
Kither and Ihrel were passed out on the ground.  There was no way DragonGirl could help her friends, 
and it was fueling her temper tantrum.  The only outlet she had, Cealen concluded, was violence. </p>
<p style="text-indent: 50px">
“STOP HIDING!”  DragonGirl screeched.  She unloaded all her rounds, and the gun clicked in her 
hand.  “When I find you…!”  She fumbled with the gun.  Her breathing was fast, making her hands 
shake when she reached in her pocket to reload the gun.  This was their chance!  DragonGirl was 
distracted and couldn’t fire at them.  Cealen rushed over to the door with Antares.  He grabbed 
the door handle, but it turned in his hand.  Someone was waiting for them!  Cealen held his breath 
as it opened.  Quickly, Cealen and Antares were pulled inside, and the door was slammed shut and 
locked.  Cealen’s adrenaline was running out.  Instead of maintaining his hyper focus, he was 
starting to panic.  His head was feeling light, and his chest hurt.  Inside the staff area were 
two people in hoods.  A man braced a chair under the door knob to secure it.  He didn’t look at 
Cealen or Antares.  He leaned his back against the door and grabbed his gun.  Cealen swallowed 
back his fear. </p>
<p style="text-indent: 50px">
“You aren’t supposed to be in here!”  Antares groaned.  This was making things complicated.  “If 
they see you,” He started before he grabbed his knee.  He was pretty sure Ihrel rotated it 
during his fight.  He was too exhausted to free himself and Cealen from the <i>FNX</i> members 
that showed up. While he was grateful for the save, it only made matters worse.</p>
<p style="text-indent: 50px">
“They won’t.”  A woman said, cocking her gun.  “Are you alright, Antares?  Can you walk?”  
Cealen took in a breath as he glanced at her.  It was the woman with fiery red hair he had bumped 
into.  The world stopped under him, and the danger was pushed to the side.  This woman was more 
amazing than Cealen remembered.  Her eyes were burning with determination when she stared at 
him.  He melted onto the floor, not knowing what to say.  Her hood was up, and she was dressed 
to conceal her appearance, but Cealen could see her face this time.  She was even more beautiful
than he remembered. </p>
<p style="text-indent: 50px">
“It’s you.”  Cealen muttered under his breath.  The woman smiled and huffed out a laugh. </p>
<p style="text-indent: 50px">
The door shook, breaking Cealen out of his trance.  Before anyone could say anything, 
DragonGirl fired at the door knob.  “Go!”  The woman said, pushing Antares and Cealen toward the back.  
“There is an emergency exit in the back.  A car is waiting.”  When Cealen turned to look back 
at her, she smirked at him.  “We’ll save the introductions for when you are safe.”  She 
blew Cealen a kiss that started his heart racing.  This was the woman who was snooping 
around last night.  He couldn’t see the pin with the phoenix on it, but the pair were dressed 
down so as not to be recognized. </p>
<p style="text-indent: 50px">
“Help me.”  Antares groaned.  He was in for it now.  <i>DNA</i> controlled the press in Niveal.  
Stories about this event were going to paint his association as the villains. </p>
<p style="text-indent: 50px">
“STOP HIDING ANTARES!  You will pay for this!”  DragonGirl shouted, shooting at the door.  
“Your gang is through!”  Antares sighed a heavy sigh.  This wasn’t going to end well for him.  
Cealen watched as the mysterious pair that showed up nodded to each other and fired back at 
DragonGirl.  She screeched, and Cealen’s heart nearly stopped. </p>
<p style="text-indent: 50px">
“Hurry.”  Antares sighed, pulling Cealen to the exit.  “The sooner we get to <i>EYE</i>, the 
sooner we can start planning out how to explain this.”  It was going to be a headache for his 
team. </p>
<p style="text-indent: 50px">
“What do you mean?”  Cealen asked, finally tearing his eyes away from the man and woman.  
“<i>DNA</i> attacked us!  What explaining do we have to do?  They are the ones that have to 
explain their actions.”  Cealen helped Antares into an old Mazda that was waiting outside.  
He glanced at the driver.  On the man's hat was a silver pin.  The phoenix stood out in the 
sunlight, along with the letters <i>FNX</i>.  He let out his breath as he settled in the back 
with Antares. </p>
<p style="text-indent: 50px">
“<i>DNA</i> controls the media.”  Antares stated, relaxing in the seat. </p>
<p style="text-indent: 50px">
“Is that so?”  Cealen asked.  He didn’t say it out loud, but Cealen would make sure Niveal 
knew what really happened.  He had an article ready to submit, but he hadn’t done so yet.  
<i>DNA</i> showing up at the motel interrupted his work.  If they thought they could control 
the perception of the people, he would prove them wrong. </p>
<p style="text-indent: 50px">
Antares sighed.  He smirked at the driver as the man glanced at him through the rearview.  
“Where did Jas say to take us?”  Antares asked sarcastically. Control over the situation 
was out of his hands now.  This escalated to something more than he could handle, and 
Antares was glad <i>FNX</i> was here to help.  At least his people got away before the 
fighting started. </p>
<p style="text-indent: 50px">
“To <i>EYE</i> house, of course.”  The driver said, glancing at Cealen.  “Why would you 
think otherwise?”  He chuckled before starting the engine and driving away from the grocery 
store.  Cealen took a breath in surprise.  The beautiful woman and her partner were being left 
behind! </p>
<p style="text-indent: 50px">
“Wait!  What about the others?”  Cealen asked. </p>
<p style="text-indent: 50px">
“What others?”  The driver laughed, not stopping.  “Only the two of you were in the store.  
Right, Antares?”  Antares chuckled and patted Cealen on the shoulder. </p>
<p style="text-indent: 50px">
“It’s alright, Cealen.”  Antares muttered.  “<i>FNX</i> isn’t the top club in Niveal for 
nothing.  All the members are very capable.”  He held his hand to the driver.  “This is Caleb.  He’s 
an elite member of <i>FNX</i>.  Trust him.”  Antares offered.  Cealen rubbed his chest.  
His heart was still hammering. </p>
<p style="text-indent: 50px">
“Then may I make a request!”  Cealen spoke up, surprising the two.  Now that Antares was safe, 
and they were driving away from the mayhem, Cealen needed to find Allyson.  “Please, Mr. Caleb, 
I fear for my partner.  She was at the-,” he started before Caleb started to laugh. </p>
<p style="text-indent: 50px">
“She was at the mixer being held at the convention center?”  Caleb asked.  He turned his blinker 
on and blended into traffic seamlessly.  They were headed to the <i>EYE</i> headquarters, but Caleb 
knew to take the long way.  There was a <i>DNA</i> car that pulled out of a parking spot near the motel.  
No doubt they were following his car.  The license plate was current and valid, but it was under a 
fake name.  Caleb would go for a drive, maybe stop at a restaurant once they lost the tail, and 
then take Antares and Cealen back to the <i>EYE</i> house. </p>
<p style="text-indent: 50px">
“Yes!”  Cealen answered.  “Please, I need to find her.  She might be hurt.” </p>
<p style="text-indent: 50px">
“Allyson, right?”  Caleb asked, settling in his seat.  He turned to get on the freeway.  
“Yeah… She was hurt.”  Caleb merged onto the freeway when the light turned green.  Cealen’s blood 
ran cold.  He covered his mouth, not knowing what to say next.</p>
<p style="text-indent: 50px">
“This isn’t the way to the <i>EYE</i> house.”  Antares noticed, looking out the window.  
“Where are we going?”  Caleb adjusted his mirror to look in the back seat.  When he saw Cealen’s 
distressed expression, he let out a sigh. </p>
<p style="text-indent: 50px">
“Don’t worry.  Your friend Allyson is in good hands.”  Caleb said easily.  His eyes jumped to 
Antares.  “We are just taking the long way around to the <i>EYE</i> house, Antares.  
Don’t you worry either.”  As they drove on the freeway, a billboard for fast food flashed by.  
Niveal had a few decent places to eat, but nothing was better than The Banquet Hall.  “Are you 
guys hungry?  That was quite the excitement today.”
`,
          isAvailable: true,
        },
        {
          id: 'chapter-3',
          chapterNumber: 3,
          title: 'The Empire Makes Waves',
          content: '<p>The sun rose over the mountains...</p>',
          isAvailable: false, // This chapter is not yet released
        },
        // Add more chapters here as they are released
      ],
      isMenuVisible: false, // Start with the mobile menu hidden
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },
    handleResize() {
      // Show the menu by default on large screens
      this.isMenuVisible = window.innerWidth > 768;
    },
    scrollToChapter(chapterId) {
      const element = document.getElementById(chapterId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        // Close the menu after clicking a link
        if (window.innerWidth <= 768) {
          this.isMenuVisible = false;
        }
      }
    },
    /*rateChapter(chapterId, rating) {
      console.log(`User rated chapter ${chapterId} with a ${rating}.`);
    },*/
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // Call it once on mount to set initial state
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style scoped>

.story-page {
  max-width: 800px;
  margin: 0 auto;
  font-family: 'Georgia', serif;
}

.story-header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
  padding: 10px 0;
  border-bottom: 1px solid #ccc;
}
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 800px;
  margin: 0 auto;
}
/* Base styles for navigation (desktop-first approach) */
.chapter-navigation {
  display: block; /* By default, show navigation */
  margin-top: 10px;
}
.quick-links {
  list-style-type: none;
  padding: 10;
  flex-wrap: wrap;
  gap: 15px;
  text-align: center;
}

.quick-links li {
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  padding: 10px;
}

.quick-links a {
  text-decoration: none;
  color: #007bff;
  font-weight: bold;
}

.disabled-link a {
  color: #888;
  pointer-events: none;
}

.rating-buttons {
  display: flex;
  gap: 2px;
}

.thumbs-up, .thumbs-down {
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0;
}

.story-content {
  margin-top: 20px;
}

.chapter-section {
  margin-bottom: 40px;
}

.chapter-text {
  text-align: justify;
  line-height: 1.6;
  font-size: 1.1rem;
}
.chapter-text p {
    text-indent: 4em;
    padding: 0;
    margin-bottom: 0em
}
.toprow{
  display: flex;
  align-items: center;
  text-align: left;
  max-height:190px;
  background-color: #d6d6c2;
}
h1 {
  display: flex;
  font-size:40px;
  padding:10px 10px;
  max-height:90px;
}
.toprow img {
  display: flex;
  width: 87px;
  height:107px;
}
.welcome p {
    padding: 5px;
    line-height: 1.6;
    text-align: justify;
}


.hamburger-button, .close-button {
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  display: none; /* Hide by default on large screens */
}

@media (max-width: 768px) {
  .header-container {
    flex-direction: column;
  }

  .hamburger-button {
    display: block; /* Show hamburger button */
  }
  
  /* Hide the full navigation menu initially on mobile */
  .chapter-navigation {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    width: 250px;
    height: 100%;
    background: #f8f9fa;
    padding: 20px;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
    z-index: 20;
    flex-direction: column;
    align-items: flex-start;
  }

  /* When 'isMenuVisible' is true, show the mobile menu with a slide-in animation */
  .chapter-navigation.mobile-nav-visible {
    display: flex; /* Override display: none */
    animation: slideIn 0.3s forwards;
  }

  .quick-links {
    flex-direction: column;
    gap: 10px;
  }

  /* Show the close button on mobile */
  .close-button {
    display: block;
    align-self: flex-end; /* Align the close button to the top-right */
  }

  /* Optional: Animation for the slide-in menu */
  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

}
</style>